import DateFnsUtils from "@date-io/date-fns";
import { Slide, TextField } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from "@material-ui/pickers";
import { Auth, JS } from "aws-amplify";
import axios from "axios";
import html2canvas from "html2canvas";
import moment from "moment";
import React from "react";
import { Alert, Modal } from "react-bootstrap";
import { connect } from "react-redux";
import Cookies from "universal-cookie";
import customStyle from "../../../Assets/CSS/stylesheet_UHS";
import configuration from "../../../configurations";
import i18n from "../../../i18next";
import CommonTable from "../../CommonScreens/commonTable";
import Sample from "../../CommonScreens/sampleTextField";
import Loader from "../../loader";
import SignScroll from "./SignScroll";
import customeClasses from "./SubmitApplication.css";
import TextSignature from "./TextSignature";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Check} from "@material-ui/icons";
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import CloseIcon from '@material-ui/icons/Close';
import './FullModal.css'

const cookies = new Cookies();

// SSN encryption (Web Crypto API, RSA-OAEP/SHA-256) — the /ssn/public-key endpoint hands back a
// base64-encoded SPKI DER public key; every SSN is encrypted with it client-side before it ever
// leaves the browser, so the backend only ever sees ciphertext over the wire.
const importSsnPublicKey = (base64Spki) => {
  const binaryDer = Uint8Array.from(atob(base64Spki), (c) => c.charCodeAt(0));
  return window.crypto.subtle.importKey(
    "spki",
    binaryDer.buffer,
    { name: "RSA-OAEP", hash: "SHA-256" },
    false,
    ["encrypt"]
  );
};

const encryptSsn = async (cryptoKey, plainSsn) => {
  const encoded = new TextEncoder().encode(plainSsn);
  const cipherBuffer = await window.crypto.subtle.encrypt({ name: "RSA-OAEP" }, cryptoKey, encoded);
  const cipherBytes = new Uint8Array(cipherBuffer);
  let binary = "";
  for (let i = 0; i < cipherBytes.length; i++) binary += String.fromCharCode(cipherBytes[i]);
  return btoa(binary);
};

const styles = (props) => ({
  colorPrimary: {
    backgroundColor: "#f2f2f2",
    width: "100%",
    marginTop: "24px",
    height: "10px",
    marginBottom: "34px",
  },
  barColorPrimary: {
    backgroundColor: "#3399cd",
  },
});

const ViewButton = withStyles(customStyle.viewBtn)(Button);

const CssTextField = withStyles(() => ({
  root: {
    "& .MuiInput-root": {
      "&:hover:not($disabled):not($focused):not($error):before": {
        borderBottom: "2px solid #1a2c40",
      },

      "&.MuiInput-underline.Mui-focused:after": {
        borderBottom: "2px solid #1a2c40",
      },
    },
  },
}))(TextField);

const WizardButton = withStyles(customStyle.viewBtn)(Button);

const FinishButton = withStyles(customStyle.proceedBtn)(Button);

const CustomeButton = withStyles(customStyle.viewBtn)(Button);

const NextButton = withStyles(customStyle.NextButton)(Button);

const BackButton = withStyles(customStyle.backBtn)(Button);

const PurpleRadio = withStyles(customStyle.radioBtn)((props) => (
  <Radio color="default" {...props} />
));

// Same filled background/underline treatment the Sample text field uses (customStyle.textField),
// so this plain MUI TextField matches it exactly instead of falling back to MUI's default fill.
const FilledTextField = withStyles(customStyle.textField)(TextField);

const AUTH_PDF_URL =
  "https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Sharing-Program-Authorizations.pdf";

const AUTH_PDF_SFF_URL = 
"https://carynhealth-memberportal-prod-documents.s3.us-east-2.amazonaws.com/Important+Documents/UHS-Senior-65-Sharing-Program-Authorizations-(Phase-1).pdf"

// Formats a bare 10-digit phone number for display as "+1 707-455-5568" — the raw digits (no
// country code, no separators) are what's actually stored in state/sent to the save API.
const formatPhoneDisplay = (countryCode, digits) => {
  digits = (digits || "").replace(/\D/g, "").slice(0, 10);
  let parts = [];
  if (digits.length > 0) parts.push(digits.slice(0, 3));
  if (digits.length > 3) parts.push(digits.slice(3, 6));
  if (digits.length > 6) parts.push(digits.slice(6, 10));
  let formatted = parts.length > 1 ? parts[0] + "-" + parts.slice(1).join("-") : (parts[0] || "");
  return digits ? `${countryCode} ${formatted}` : "";
};

var reenrollmentFlag = false;

class SubmitApplication extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 0,
      // Carrier-wise ENROLL flow only: a leading, SSN-collection step shown before the count-based
      // screens below (terms, financial auth, etc.) — gated independently of count so it doesn't
      // disturb the legacy count machinery other flows rely on.
      showMemberSSNScreen: !!props.enrollingStepperType,
      memberSSNList: [],
      progress: 0,
      loaderShow: false,
      authorization: false,
      healthTerms: false,
      fullName: "",
      submitDone: false,
      modalShow: false,
      successModal: false,
      popUpMsg: "",
      modalShowPrivacy: false,
      modalShow4Privacy: false,
      authModalShow: false,
      authModalShow4: false,
      privacyPolicy: false,
      privacyPolicy4: false,
      authorize: false,
      authorize4: false,
      authorize1: false,
      nextDisabled: true,
      finaceAuth: false,
      financeAuthModalShow: false,
      authModalShow1: false,
      authorize44: false,
      paymentScreenModal: false,
      planFamilyDetails: [],
      programName: "",
      otherQuote: [],
      todayPayment: [],
      text: "",
      recurringPayment: [],
      totalCost: "",
      headerData: [],
      tooltipData: [],
      plansList: [],
      totalPayment: {},
      termsAccepted: {},
      activeTermsPopup: null,
      consentSections: [],
      consentSectionIndex: 0,
      enrollFlag: false,
      phoneNumber: "",
      targetDate: null,
      targetDateModal: false,
      carrierEffectiveDateModal: false,
      carrierNewEffectiveDate: null,
      dateErr: false,
      birthDtFocus: false,
      birthDt: false,
      agentName: "",
      email: "",
      reqType: "",
      contactUpdateModal: false,
      contactUpdateEmail: "",
      contactUpdatePhone: "",
      contactUpdateCountryCode: "+1",
      contactUpdateOriginalEmail: "",
      contactUpdateOriginalPhone: "",
      pendingRequestType: "",
      tableData: null,
      popTable: null,
      FamilyDetailsMoreInfoModal: false,
      fromMember: false,
      fromLogin: false,
      enroll: false,
      showCommonErrorModal: false,
      inviteStatusModal: false,
      inviteStatusFlag: false,
      inviteStatus: "",
      draftDayModal: false,
      draftDaySelected: "",
      memberPlanInfo: "",
      effectivePaymentDate: "",
      firstPaymentDate: "",
      firstPaymentAmount: "",
      todayDate: "",
      initialApplicationFee: "",
      subsequentPaymentDate: "",
      creditCard: false,
      openSignScroll: false,
      clearSign: false,
      signType: "stylized",

      payflag: null,

      canvasChanged: false,
      canvasDone: false,
      imgUrl: "",
      signScrollImage: null,
      isValidFullName: true,
      submitText: null,
      isEnrolled: false,
      frontCard:'',
      backCard:'',
      error: '',
      msg:'',
      showMessage: false,
      currentSide:'front',
      disableSubmit:false,
      isMaximized: false,
      carrierCode: JSON.parse(sessionStorage.getItem("STATE_PARAM")).actionType,
    };

    this.child = React.createRef();
    this.fileInputRef = React.createRef();
  }

  toggleMaximize = () => {
    this.setState(prevState => ({ isMaximized: !prevState.isMaximized }));
  };

  /*------------------Finance Auth Modal------------------------*/
  showFinanceAuthModal = (event) => {
    this.setState(
      {
        financeAuthModalShow: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  hideModalFinaceAuth = (event) => {
    this.setState(
      {
        financeAuthModalShow: false,
        authorization: false,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  hideModalFinaceAuth11 = (event) => {
    if (this.state.authorization == false) {
      this.setState(
        {
          financeAuthModalShow: false,
          authorization: false,
        },
        () => {
          this.getDisabled();
        }
      );
    } else {
      this.setState(
        {
          financeAuthModalShow: false,
          authorization: true,
        },
        () => {
          this.getDisabled();
        }
      );
    }
  };

  acceptFinaceAuth = () => {
    this.setState(
      {
        financeAuthModalShow: false,
        authorization: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  /*================================ privacy policy modal ===============================*/
  hideModalPrivacy = (event) => {
    this.setState(
      {
        modalShowPrivacy: false,
        privacyPolicy: false,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  hideModalPrivacy11 = (event) => {
    if (this.state.privacyPolicy == true) {
      this.setState(
        {
          modalShowPrivacy: false,
          privacyPolicy: true,
        },
        () => {
          this.getDisabled();
        }
      );
    } else {
      this.setState(
        {
          modalShowPrivacy: false,
          privacyPolicy: false,
        },
        () => {
          this.getDisabled();
        }
      );
    }
  };

  /*---------------------  privacy 4--------- */
  hideModal4Privacy = (event) => {
    this.setState(
      {
        authModalShow4: false,
        authorize44: false,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  hideModal4Privacy11 = (event) => {
    if (this.state.privacyPolicy4 == false) {
      this.setState(
        {
          authModalShow4: false,
          privacyPolicy4: false,
        },
        () => {
          this.getDisabled();
        }
      );
    } else {
      this.setState(
        {
          authModalShow4: false,
          privacyPolicy4: true,
        },
        () => {
          this.getDisabled();
        }
      );
    }
  };

  showModalPopup = (event) => {
    if (event.target.checked) {
      this.setState(
        {
          modalShow: false,
          privacyPolicy: true,
        },
        () => {
          this.getDisabled();
        }
      );
    } else {
      this.setState(
        {
          modalShow: false,
          privacyPolicy: false,
        },
        () => {
          this.getDisabled();
        }
      );
    }
  };

  viewPlanHideModal = (event) => {
    this.setState(
      {
        modalShowPrivacy: false,
        privacyPolicy: false,
        loaderShow: false,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  checkPrivacy = (event) => {
    if (event.target.checked) {
      this.setState(
        {
          privacyPolicy: true,
        },
        () => {
          this.getDisabled();
        }
      );
    } else {
      this.setState(
        {
          privacyPolicy: false,
        },
        () => {
          this.getDisabled();
        }
      );
    }
  };

  showPlansModalPrivacy = () => {
    if (this.state.privacyPolicy == true) {
      this.setState({ privacyPolicy: true, modalShowPrivacy: true });
    } else {
      this.setState(
        {
          modalShowPrivacy: true,
          privacyPolicy: false,
          // loaderShow : true
        },
        () => {
          this.getDisabled();
        }
      );
    }
  };

  acceptPrivacyPolicy = () => {
    this.setState(
      {
        modalShowPrivacy: false,
        privacyPolicy: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  acceptPrivacyPolicy4 = () => {
    this.setState(
      {
        authModalShow4: false,
        authorize44: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };
  /*================================ privacy policy modal ===============================*/

  /*============================authoroise modal ====================================*/
  authorizeHideModal = (event) => {
    this.setState(
      {
        authModalShow: false,
        authorize: false,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  authorizeHideModal22 = (event) => {
    if (this.state.authorize == false) {
      this.setState(
        {
          authModalShow: false,
          authorize: false,
        },
        () => {
          this.getDisabled();
        }
      );
    } else {
      this.setState(
        {
          authModalShow: false,
          authorize: true,
        },
        () => {
          this.getDisabled();
        }
      );
    }
  };

  authorizeHideModal1 = (event) => {
    this.setState(
      {
        authModalShow1: false,
        authorize1: false,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  // authorizeHideModal3 = (event) => {
  //   this.setState(
  //     {
  //       authModalShow3: false,
  //       authorize: false,
  //     },
  //     () => {
  //       this.getDisabled();
  //     }
  //   );
  // };

  authorizeHideModal111 = (event) => {
    if (this.state.authorize1 == false) {
      this.setState(
        {
          authModalShow1: false,
          authorize1: false,
        },
        () => {
          this.getDisabled();
        }
      );
    } else {
      this.setState(
        {
          authModalShow1: false,
          authorize1: true,
        },
        () => {
          this.getDisabled();
        }
      );
    }
  };

  showAuthorizeModalPopup = (event) => {
    this.setState(
      {
        authModalShow: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  toggleSignScrollModal = (mode) => {
    this.setState({
      openSignScroll: mode,
    });
  };

  changeSignType = (e, v) => {
    this.setState({
      signType: v,
      fullName: v === "stylized" ? "" : this.state.fullName,
    });
  };

  handleSignClear = () => {
    this.child.current.clearCanvas();
  };

  dataURItoBlob(dataURI) {
    let byteString = atob(dataURI.split(",")[1]);

    let mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

    let ab = new ArrayBuffer(byteString.length);
    let ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ab], { type: mimeString });
  }

  handleSignDone = () => {
    this.child.current.cropImageFromCanvas();
    this.child.current.disableCanvas();

    this.setState({
      canvasDone: true,
      canvasChanged: false,
      disableSubmit:false
    });
    this.nameChangeHandler(this.state.fullName, this.state.fullName !== "");
    const img = this.child.current.convertCanvasToImage();

    this.setState({
      isValidFullName: this.state.fullName === "" ? false : true,
    });

    return img.src;
  };

  showAuthorizeModalPopup4 = (event) => {
    this.setState(
      {
        authModalShow4: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  showAuthorizeModalPopup2 = (event) => {
    this.setState(
      {
        authModalShow1: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  showAuthorizeModalPopup3 = (event) => {
    this.acceptAuthorization3(event)
  };

  checkFellowshipStatus = () => {
    this.setState(
      {
        authorize: !this.state.authorize,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  acceptAuthorization = () => {
    this.setState(
      {
        authModalShow: false,
        authorize: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  acceptAuthorization1 = () => {
    this.setState(
      {
        authModalShow1: false,
        authorize1: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  acceptAuthorization3 = (e) => {
    console.log("acceptAuthorization3 called", e.target.checked);
    this.setState(
      {
        // authModalShow3: false,
        authorize: e.target.checked,
      },
      () => {
        this.getDisabled();
      }
    );
  };
  /*============================authoroise modal ====================================*/

  showPlansModal1 = (event) => {
    this.setState({
      modalShow: true,
    });
  };

  reduceProgress = () => {
    if (this.props.enrollingStepperType && this.state.showMemberSSNScreen) {
      this.props.handlePrev();
      return;
    }
    // Terms screen (count 1) pages through one consent section per step — back moves to the
    // previous section first, and only re-shows the SSN step once already on the first section.
    if (this.props.enrollingStepperType && this.state.count === 1 && this.state.consentSectionIndex > 0) {
      this.setState({ consentSectionIndex: this.state.consentSectionIndex - 1 }, () => this.getDisabled());
      return;
    }
    if (this.props.enrollingStepperType && this.state.count === 1) {
      this.setState({ showMemberSSNScreen: true });
      return;
    }
    if (this.state.count > 0) {
      // This flow only ever uses count 1 (terms) and 4 (e-sign) — count 2/3 are the legacy
      // static Financial Authorization / Health Sharing screens, skipped entirely here.
      // Landing back on the terms step re-shows its last section, not the first.
      const carrierWiseBackToTerms = this.props.enrollingStepperType && this.state.count === 4;
      const prevCount = carrierWiseBackToTerms ? 1 : this.state.count - 1;
      this.setState(
        {
          count: prevCount,
          progress: (prevCount / 4) * 100,
          canvasChanged: false,
          canvasDone: false,
          fullName: "",
          ...(carrierWiseBackToTerms && { consentSectionIndex: Math.max(this.state.consentSections.length - 1, 0) }),
        },
        () => {
          this.getDisabled();
        }
      );
    }else{
      this.props.backClick()
    }
  };

  increaseProgress = async () => {
    if (this.props.enrollingStepperType && this.state.showMemberSSNScreen) {
      this.saveMemberSSNs();
      return;
    }
    // Terms screen (count 1) pages through one consent section per step before actually
    // leaving the terms step.
    if (this.props.enrollingStepperType && this.state.count === 1 && this.state.consentSectionIndex < this.state.consentSections.length - 1) {
      this.setState({ consentSectionIndex: this.state.consentSectionIndex + 1 }, () => this.getDisabled());
      return;
    }
    // Carrier-wise ENROLL flow: policy/financialPolicy/sharePolicy are all captured in one
    // shot by carrier_application_submit at final submit, so the legacy per-step
    // saveAuthorization ping is unnecessary here — just advance locally. Terms (count 1) goes
    // straight to e-sign (count 4) — count 2/3 are the legacy static Financial
    // Authorization / Health Sharing screens, never shown in this flow.
    if (this.props.enrollingStepperType) {
      if (this.state.count < 4) {
        const nextCount = this.state.count === 1 ? 4 : this.state.count + 1;
        this.setState(
          {
            count: nextCount,
            progress: (nextCount / 4) * 100,
          },
          () => {
            this.getDisabled();
          }
        );
      }
      return;
    }
    this.setState({
      loaderShow: true,
    });
    let obj = new Object();
    obj.subId = this.props.subId;
    if(this.state.count === 0){
      const frontCardResponse = await this.uploadCardImage(this.state.frontCard, 'front');
      const backCardResponse = await this.uploadCardImage(this.state.backCard, 'back'); 
      // if(backCardResponse.error || frontCardResponse.error){
      //   this.setState({msg:'Error in uploading image. Please select other image'})
      // }else{
          let medicarCards =  {
            "FrontCard": frontCardResponse.response,
            "BackCard": backCardResponse.response
        };
          obj.medicareIdCard = JSON.stringify(medicarCards);
      // }
    }else if (this.state.count === 1) {
      obj.policy = true;
      obj.ipAddress = sessionStorage.getItem("PUBLIC-IP");
    } else if (this.state.count === 2) {
      obj.financialPolicy = true;
    } else if (this.state.count === 3) {
      obj.sharePolicy = true;
    }

    axios
      .post(configuration.baseUrl + "/enrollment/saveAuthorization", obj)
      .then((response) => {
        if (response.data.code === 200) {
          if (this.state.count < 4) {
            this.setState(
              {
                count: this.state.count + 1,
                progress: ((this.state.count + 1) / 4) * 100,
                loaderShow: false,
              },
              () => {
                this.getDisabled();
              }
            );
          }
        }
      });
  };

  nameChangeHandler = (val, isValid, parentObj) => {
    if (isValid) {
      this.setState({
        fullName: val,
        isValidFullName: true,
        disableSubmit:false
      });
    } else {
      this.setState({
        fullName: "",
        isValidFullName: false,
      });
    }
  };

  getPaymentMode = () => {

    fetch(
      configuration.baseUrl +
        "/setuppayment/getPaymentDetails/" +
        this.props.subId
    )
      .then((response) => response.json())
      .then((response) => {
        if (response.response) {
          var totalAmount = response.response.amount;

          if (response.response.paymentType === "CC") {
            var calApplicatioFee = 75 + 75 * 0.035;
            calApplicatioFee = calApplicatioFee.toFixed(2);
            if(sessionStorage.getItem('CLIENT_ID') == '5742' || sessionStorage.getItem('CLIENT_ID') == '4599'){
             calApplicatioFee = 0
            }
            this.setState({
              initialApplicationFee: "$75",
              firstPaymentAmount: (totalAmount - calApplicatioFee).toFixed(2),
              creditCard: true,
            });
          } else {
            var calApplicatioFee = 75
            if(sessionStorage.getItem('CLIENT_ID') == '5742' || sessionStorage.getItem('CLIENT_ID') == '4599'){
              calApplicatioFee = 0
             }
            this.setState({
              initialApplicationFee: "$75",
              firstPaymentAmount: (totalAmount - calApplicatioFee).toFixed(2),
              creditCard: false,
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  //--- Draft Day ------>

  openDraftDayModal = () => {
    this.setState({
      loaderShow: true,
      addressModal: false,
      draftDayModal: true,
    });

    fetch(
      configuration.baseUrl +
        "/setuppayment/getPaymentDetails/" +
        this.props.subId
    )
      .then((response) => response.json())
      .then((response) => {
        if (response.response) {
          var totalAmount = response.response.amount;

          if (response.response.paymentType === "CC") {
            var calApplicatioFee = 75 + 75 * 0.035;
            calApplicatioFee = calApplicatioFee.toFixed(2);
            if(sessionStorage.getItem('CLIENT_ID') == '5742' || sessionStorage.getItem('CLIENT_ID') == '4599'){
             calApplicatioFee = 0
            }
            this.setState({
              initialApplicationFee: "$75",
              firstPaymentAmount: (totalAmount - calApplicatioFee).toFixed(2),
              creditCard: true,
            });
          } else {
            var calApplicatioFee = 75
            if(sessionStorage.getItem('CLIENT_ID') == '5742' || sessionStorage.getItem('CLIENT_ID') == '4599'){
              calApplicatioFee = 0
             }
            this.setState({
              initialApplicationFee: "$75",
              firstPaymentAmount: (totalAmount - calApplicatioFee).toFixed(2),
              creditCard: false,
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });

    var tDate = new Date();

    // Same cookiesData.actionType used as the product/plan type segment elsewhere
    // (e.g. submitCarrierApplication's carrier_application_submit URL).
    let draftDayCookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM')) || {};
    let draftDayProductType = draftDayCookiesData.actionType;
    fetch(configuration.baseUrl + "/plan/getMemberPlan/" + this.props.subId + "/" + draftDayProductType)
      .then((selectedPlan) => selectedPlan.json())
      .then((selectedPlan) => {
        if (selectedPlan.response) {
          this.setState({
            loaderShow: false,
            memberPlanInfo: selectedPlan.response,
            //firstPaymentAmount: getFirstPaymentAmount,
            todayDate: moment(tDate).format("dddd, MMMM Do, YYYY"),
          });

          console.log("==selectedPlan==", selectedPlan.response);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  answerChangeHandler = (event, name, optionId) => {
    if (name === "radio") {
      var paymentDate = moment(this.state.targetDate)
        .subtract(event.target.value, "days")
        .format("MM/DD/YYYY");
      var getSubsequentPaymentDate = moment(this.state.targetDate)
        .add(1,'M')
        .subtract(event.target.value, "days")
        .format("MM/DD/YYYY");

      var varDate = new Date(paymentDate);
      var today = new Date();

      if (varDate >= today && this.props.agentDetails.clientId != '4599' && this.props.agentDetails.clientId != '5742') {
        console.log("future date");
      } else {
        console.log("past date");
        paymentDate = today;
      }
      this.setState({
        draftDaySelected: event.target.value,
        effectivePaymentDate: moment(this.state.targetDate).format(
          "dddd, MMMM Do, YYYY"
        ),
        firstPaymentDate: moment(paymentDate).format("dddd, MMMM Do, YYYY"),
        subsequentPaymentDate: getSubsequentPaymentDate,
      });
    }
  };

  handleDraftModalClose = () => {
    this.setState({
      draftDayModal: false,
      draftDaySelected: "",
    });
  };

  submitDraftDay = () => {
    let data = {
      subId: this.state.memberPlanInfo.subId,
      planId: this.state.memberPlanInfo.planId,
      planCode: this.state.memberPlanInfo.planCode,
      amount: this.state.memberPlanInfo.amount,
      targetDate: moment(this.state.targetDate).format("YYYY-MM-DD"),
      acsm: this.state.memberPlanInfo.acsm,
      draftDay: parseInt(this.state.draftDaySelected),
      appFee :  this.state.memberPlanInfo.appFee,
      membershipDues : this.state.memberPlanInfo.membershipDues,
      planType : this.state.memberPlanInfo.planType,
      surchargesAmount: "0.00",
    };

    console.log("====saveMemberPlan===", data);

    axios
      .post(configuration.baseUrl + "/plan/saveMemberPlans", data)
      .then((response) => {
        this.setState({
          loaderShow: false,
          draftDayModal: false,
          targetDateModal: false,
        });
        this.saveApplication();
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          successModal: true,
          popUpMsg: "Internal Server Error",
          loaderShow: false,
        });
      });
  };

  saveTargetDate = () => {
    //-- Not using this call as we are showing draft day [Safal 29 Oct]
    this.setState({ targetDateModal: false, loaderShow: true });

    let date = moment(this.state.targetDate).format("YYYY-MM-DD");
    let obj = {
      subId: this.props.subId,
      targetDate: date,
    };
    axios
      .post(configuration.baseUrl + "/plan/updateBenefitBeginDate", obj)
      .then((res) => {
        console.log("============ res ===============");
        console.log(res);
        if (res.data.code === 200) {
          this.saveApplication();
        } else {
          this.setState({
            successModal: true,
            popUpMsg: "Internal Server Error",
            loaderShow: false,
          });
        }
      });
  };

  uploadImage = async (file) => {
    this.setState({
      loaderShow: true,
    });
    let formData = new FormData();
    formData.append(
      "file",
      file,
      `${
        JSON.parse(localStorage.getItem("CurrentLoginUser")).id
      }-${new Date().getTime()}.png`
    );

    await axios
      .post(configuration.baseUrl + "/enrollment/uploadImage", formData)
      .then((res) => {
        this.setState({
          // loaderShow: false,
          imgUrl: res.data.response,
        });
        return res.data.response;
      });
  };

  uploadCardImage = async (file, cardType) => {
      this.setState({
          loaderShow: true,
      });
      let formData = new FormData();
      formData.append(
          "file",
          file,
      );
      formData.append("type", "IDCARD");

      try {
          const res = await axios.post(configuration.baseUrl + "/enrollment/uploadImage", formData);
          this.setState({
              loaderShow: false,
          });
          return { cardType, response: res.data.response };
      } catch (error) {
          console.error("Error uploading image:", error);
          this.setState({
              loaderShow: false,
          });
          return { cardType, error: error.message };
      }
  };

  textSignatureToImage = () => {
    let node = document.getElementById("signTextContent");
    return html2canvas(node).then(function (canvas) {
      return canvas.toDataURL("image/png");
    });
  };

  // Carrier-wise final submit for the Cognito ENROLL flow: uploads the e-sign image via the
  // same uploadImage() used by the legacy flow, then posts to carrier_application_submit
  // (scoped to this specific carrier via enrollingStepperType) instead of the legacy
  // saveAuthorization/enrollment calls. financialPolicy/sharePolicy map to the counts 2/3
  // checkboxes (authorization/healthTerms), which are unchanged from the legacy flow —
  // only count===1's terms screen was replaced with the carrier-wise one.
  // Same lapsed-effective-date guard as the legacy targetDateModal flow, but sourced
  // from setuppayment/paymentSummary (this carrier-wise flow's own source of the
  // effective date) instead of getMemberPlan's targetDate.
  submitCarrierApplication = async () => {
    this.setState({ loaderShow: true });

    try {
      const paymentSummaryRes = await axios.get(configuration.baseUrl + "/setuppayment/paymentSummary/" + this.props.subId);
      const effectiveDate = paymentSummaryRes.data && paymentSummaryRes.data.response && paymentSummaryRes.data.response.effectiveDate;
      if (effectiveDate && moment(effectiveDate).isBefore(moment(), "day")) {
        this.setState({
          loaderShow: false,
          carrierEffectiveDateModal: true,
          carrierNewEffectiveDate: moment().add(2, "days").toDate(),
        });
        return;
      }
    } catch (error) {
      console.log(error);
    }

    await this.finalizeCarrierSubmit();
  };

  // Called directly by submitCarrierApplication when the effective date is still valid,
  // or after confirmCarrierEffectiveDate updates it — either way this is the actual submit.
  finalizeCarrierSubmit = async () => {
    this.setState({ loaderShow: true });
    if (this.state.signType === "stylized") {
      const img = await this.textSignatureToImage();
      await this.uploadImage(this.dataURItoBlob(img));
    }
    if (this.state.signType === "scribble") {
      await this.uploadImage(this.dataURItoBlob(this.handleSignDone()));
    }

    let obj = {
      policy: true,
      financialPolicy: this.state.authorization,
      sharePolicy: this.state.healthTerms,
      signedName: this.state.fullName,
      esign: this.state.imgUrl,
    };

    // URL now takes a third segment — the specific product/plan type within the carrier
    // (e.g. "deductible_pair"), same cookiesData.actionType used by the review-choices calls.
    let cookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM')) || {};
    let type = cookiesData.actionType;
    let carrier = cookiesData.carrier;
    axios
      .post(configuration.baseUrl + "/enrollment/carrier_application_submit/" + this.props.subId + "/" + carrier + "/" + type, obj)
      .then(() => {
        // Notifies the agency SSE channel, same as enrollment.js's saveStepperProgress /
        // notifyAuthLinkAccessed — "email" here is the subId, not an email address.
        axios.post(configuration.baseRootUrl + "/veraagency/sse/send/event", {
          email: this.props.subId,
          name: "Enrollment Portal",
          status: "Stepper",
        }).catch((error) => console.log(error));

        this.setState({ loaderShow: false });
        if (this.props.onEnrollmentSubmitted) {
          this.props.onEnrollmentSubmitted();
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loaderShow: false });
      });
  };

  // Confirms the member's newly-picked effective date (2-45 days out, enforced by the
  // date picker's min/max), then proceeds with the actual submission.
  confirmCarrierEffectiveDate = async () => {
    this.setState({ loaderShow: true });
    try {
      await axios.post(configuration.baseUrl + "/quote/member-plan/updateEffectiveDate", {
        subId: this.props.subId,
        effectiveDate: moment(this.state.carrierNewEffectiveDate).format("YYYY-MM-DD"),
      });
    } catch (error) {
      console.log(error);
    }
    this.setState({ carrierEffectiveDateModal: false });
    await this.finalizeCarrierSubmit();
  };

  beforeSaveApplication = async () => {
    this.setState({
      loaderShow: true,
    });
    if (this.state.signType === "stylized") {
      const img = await this.textSignatureToImage();
      await this.uploadImage(this.dataURItoBlob(img));
    }

    if (this.state.signType === "scribble") {
      await this.uploadImage(this.dataURItoBlob(this.handleSignDone()));
    }

    let obj = new Object();
    obj.subId = this.props.subId;
    obj.signedName = this.state.fullName;
    obj.esign = this.state.imgUrl;

    let beforeSaveCookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM')) || {};
    let beforeSaveProductType = beforeSaveCookiesData.actionType;

    await axios
      .post(configuration.baseUrl + "/enrollment/saveAuthorization", obj)
      .then((response) => {
        if (response.data.code === 200) {
          fetch(
            configuration.baseUrl + "/plan/getMemberPlan/" + this.props.subId + '/' + beforeSaveProductType
          )
            .then((selectedPlan) => selectedPlan.json())
            .then((selectedPlan) => {
              if (!this.state.isEnrolled) {
                if (selectedPlan.response) {
                  let date = moment(selectedPlan.response.targetDate);
                  let now = moment();

                  if (date < now) {
                    this.setState({
                      targetDate: date,
                      targetDateModal: true,
                      loaderShow: false,
                    });
                  } else {
                    this.saveApplication();
                  }
                }
              } else {
                this.saveApplication();
              }
            });
        }
      });
  };

  saveApplication = () => {
    this.setState({
      loaderShow: true,
    });
    console.log("payflag---", this.state.payflag);
    let data = new Object();
    data.email = this.state.email;
    data.subId = this.props.subId;
    data.esign = this.state.imgUrl; //this.props.email

    console.log(":::::::::::: obj", data);

    if (this.state.payflag===false) {
      // axios
      //   .post(configuration.baseUrl + "/setuppayment/payment", data)
      //   .then((response) => {
          if (this.state.payflag == false) {
            axios
            .post(configuration.baseUrl + "/enrollment/enrollment", data)
            .then((response) => {
              if (response.data.code === 200) {
                let evt = new CustomEvent("paymentFlag", {
                  detail: { flag: true },
                });
                window.dispatchEvent(evt);
    
                let evt1 = new CustomEvent("enroll_flag", {
                  detail: { flag: true },
                });
                window.dispatchEvent(evt1);
                localStorage.removeItem("paymentData");
                localStorage.removeItem("PAYMENT_ERROR");
                this.setState({
                  submitDone: true,
                  successModal: false,
                  count: 5,
                  loaderShow: false,
                  isSaved: true,
                  submitWaitModal: false
                });
              } else if (response.data.code === 202) {
                this.setState({
                  loaderShow: false,
                  successModal: true,
                  count: 4,
                  popUpMsg: JSON.parse(response.data.response).error_message,
                  submitWaitModal: false
                });
              } else if (response.data.code === 204) {
                this.setState({
                  loaderShow: false,
                  successModal: true,
                  count: 4,
                  popUpMsg: "The enrollment application has already been submitted and is being processed.",
                  submitWaitModal: false
                });
              } else if (response.data.code === 500) {
                this.setState({
                  loaderShow: false,
                  count: 4,
                  successModal: true,
                  popUpMsg:
                    "There was an error in processing the enrollment. Please try again later.",
                  submitWaitModal: false
                });
              } else if (response.data.code === 0) {
                this.setState({
                  loaderShow: false,
                  submitDone: false,
                  isSaved: true,
                  successModal: true,
                  popUpMsg:
                    "There was an error in processing the enrollment. Please try again later.",
                  submitWaitModal: false
                });
              }
            })
            .catch((error) => {
              console.log(error);
              this.setState({ submitWaitModal: false })
            });

          } else if (this.state.payflag == true) {
            fetch(
              configuration.baseUrl +
                "/enrollment/saveEnrollmentMember/" +
                this.props.subId
            )
              .then((response) => response.json())
              .then((response) => {
                if (response.code === 200) {
                  let evt = new CustomEvent("enroll_flag", {
                    detail: { flag: true },
                  });
                  window.dispatchEvent(evt);
                  localStorage.removeItem("paymentData");
                  localStorage.removeItem("PAYMENT_ERROR");
                  this.setState({
                    submitDone: true,
                    successModal: false,
                    count: 5,
                    loaderShow: false,
                  });
                } else if (response.code === 202) {
                  this.setState({
                    loaderShow: false,
                    submitDone: false,
                    successModal: true,
                    popUpMsg:
                      "Oops! Something's not right. If you're still having trouble, call us on (800) 921-4505",
                  });
                } else if (response.code === 500) {
                  this.setState({
                    loaderShow: false,
                    submitDone: false,
                    successModal: true,
                    popUpMsg:
                      "Oops! Something's not right. If you're still having trouble, call us on (800) 921-4505",
                  });
                } else {
                  this.setState({
                    loaderShow: false,
                    submitDone: false,
                    successModal: true,
                    popUpMsg:
                      "Oops! Something's not right. If you're still having trouble, call us on (800) 921-4505",
                  });
                }
              })
              .catch((error) => {
                this.setState({
                  loaderShow: false,
                  submitDone: false,
                  successModal: true,
                  popUpMsg:
                    "Oops! Something's not right. If you're still having trouble, call us on (800) 921-4505",
                });
              });
          }
        // })

        // .catch((error) => {
        //   console.log(error);
        // });
    } else {
      // localStorage.removeItem('paymentData');
      axios
      .post(configuration.baseUrl + "/enrollment/reenrollment", data)
      .then((response) => {
        if (response.data.code === 200) {
          let evt = new CustomEvent("paymentFlag", {
            detail: { flag: true },
          });
          window.dispatchEvent(evt);

          let evt1 = new CustomEvent("enroll_flag", {
            detail: { flag: true },
          });
          window.dispatchEvent(evt1);
          localStorage.removeItem("paymentData");
          localStorage.removeItem("PAYMENT_ERROR");
          this.setState({
            submitDone: true,
            successModal: false,
            count: 5,
            loaderShow: false,
            isSaved: true,
            submitWaitModal: false
          });
        } else if (response.data.code === 202) {
          this.setState({
            loaderShow: false,
            successModal: true,
            count: 4,
            popUpMsg: JSON.parse(response.data.response).error_message,
            submitWaitModal: false
          });
        } else if (response.data.code === 204) {
          this.setState({
            loaderShow: false,
            successModal: true,
            count: 4,
            popUpMsg: "The enrollment application has already been submitted and is being processed.",
            submitWaitModal: false
          });
        } else if (response.data.code === 500) {
          this.setState({
            loaderShow: false,
            count: 4,
            successModal: true,
            popUpMsg:
              "There was an error in processing the enrollment. Please try again later.",
            submitWaitModal: false
          });
        } else if (response.data.code === 0) {
          this.setState({
            loaderShow: false,
            submitDone: false,
            isSaved: true,
            successModal: true,
            popUpMsg:
              "There was an error in processing the enrollment. Please try again later.",
            submitWaitModal: false
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ submitWaitModal: false })
      });
    }
  };

  componentDidMount() {
    window.addEventListener("message", this.handleMessage)
    window.addEventListener("message", function (event) {
      if (event.data === "closeIframe") {
        console.log("Message received from iframe: closeIframe");
        this.setState({ showPlaid: false, loaderShow: true });
        fetch(`${process.env.REACT_APP_paymentService}customers/achCancel/${this.props.subId}`)
          .then(res => {
            axios.get(`${process.env.REACT_APP_paymentService}customers/ACH/${this.props.subId}`)
              .then((response) => {
                if (response.data.data.achVerificationStatus != "VERIFIED") {
                  this.setState({ isACHFailed: true })
                }
                this.setState({ loaderShow: false })
              })
          })
      }
    }.bind(this), false);
    this.getPaymentMode()
    if (this.props.enrollingStepperType) {
      this.fetchMemberSSNs();
      this.fetchConsentContent();
    }
    sessionStorage.setItem("current_screen", String(this.props.activeStep));
    let screenId = JSON.parse(localStorage.getItem('CurrentLoginUser')).id;
    axios.get(configuration.baseUrl + "/enrollment/saveCompletionStatus/" + screenId + "/" + sessionStorage.getItem('current_screen'))
      .then((response) => {
        if (response && response.data.code === 200) console.log(response.data.code)
      })
      .catch((error) => console.log(error));
   this.setState({
      loaderShow: true,
      privacyPolicy: false,
      authorize1: false,
      authorize: false,
      authorization: false,
      checkBox5: false,
      checkBox7: false,
      checkBox8: false,
    });
    let cookiesData = null;
    cookiesData = JSON.parse(sessionStorage.getItem("STATE_PARAM")); //cookies.get('STATE_PARAM', false);
    if (cookiesData && cookiesData.fromMember) {
      this.setState({ fromMember: true, fromLogin: false }); // for go to step select program
    } else if (cookiesData && cookiesData.fromLogin === true) {
      this.setState({ fromLogin: true, fromMember: false }); // for go to step select program
    } else {
      this.setState({ enroll: true });
    }

    let URL = "";
    if (this.props.isAgent) {
      //
      if (cookiesData && cookiesData.reEnrolledByAgent == true) {
        // from agent after enrolled
        this.setState({
          paymentScreenModal: true,
        });
      } else if (
        (cookiesData && cookiesData.fromMember == true) ||
        cookiesData.fromLogin == true
      ) {
        // from member
        this.setState({
          paymentScreenModal: false,
        });
      } else {
        this.setState({
          // from agent before enrolled
          paymentScreenModal: true,
        });
      }
    }

    let getDetails = JSON.parse(localStorage.getItem("CurrentLoginUser"));

    if (getDetails.email !== null || getDetails.email !== "") {
      this.setState({
        email: getDetails.email,
      });
    }

    console.log("=====agentDetails===");
    console.log(this.props.agentDetails);

    if (this.props.agentDetails && this.props.agentDetails.brokerId) {
      axios
        .get(
          configuration.agentURL +
            "/agent/getAgentById/" +
            this.props.agentDetails.brokerId
        )
        .then((response) => {
          // console.log(
          //   "===RESPONSE===",
          //   response.data.response.firstName +
          //     " " +
          //     response.data.response.lastName
          // );
          if(response.data.response)
          this.setState({
            agentName:
              response.data.response.firstName +
              " " +
              response.data.response.lastName,
          });
        });
    }
    
    if (this.props.isAgent) {
      URL =
        configuration.baseUrl +
        "/setupfamily/getEnrollFlagBySubId/" +
        getDetails.id; //this.props.agentDetails.subId
    } else {
      URL =
        configuration.baseUrl +
        "/setupfamily/getEnrollFlag/" +
        this.props.email;
    }
    //axios.get(configuration.baseUrl + '/setupfamily/getEnrollFlag/' + this.props.email)
    axios.get(URL).then(async (response) => {
      let enFlag = response.data.response.enrollFlag;
      let paymentFlag = response.data.response.paymentFlag;
      let agentFlag = response.data.response.agentFlag;
      reenrollmentFlag = response.data.response.reenrollmentFlag
        ? response.data.response.reenrollmentFlag
        : false;
      this.setState({
        payflag: paymentFlag,
        isEnrolled: enFlag
      });
      if (
        cookiesData &&
        (cookiesData.reEnrolledByAgent == false ||
          cookiesData.fromMember == false ||
          cookiesData.fromLogin == false)
      ) {
        axios
          .get(
            configuration.baseUrl +
              "/enrollment/getAuthorization/" +
              this.props.subId
          )
          .then((response) => {
            if (response.data.code === 200) {
              if (response.data.response.policy) {
                this.setState({
                  privacyPolicy: true,
                  authorize: true,
                  authorize1: true,
                  authorize44: true,
                  healthTerms: response.data.response.sharePolicy,
                  authorization: response.data.response.financialPolicy,
                });
              } else {
                this.setState({
                  privacyPolicy: false,
                  authorize: false,
                  authorize1: false,
                  authorize44: false,
                  healthTerms: response.data.response.sharePolicy,
                  authorization: response.data.response.financialPolicy,
                });
              }

              if (enFlag && paymentFlag) {
                if(!reenrollmentFlag)
                this.setState({
                  count: 5,
                  submitDone: true,
                  enrollFlag: enFlag,
                  loaderShow: false,
                });
                else{
                  this.setState({
                    loaderShow: false,
                    count: 1,
                    privacyPolicy: false,
                    authorize: false,
                    authorize1: false,
                    authorize44: false,
                    healthTerms: false,
                    authorization: false,
                    enrollFlag: true,
                  });
                }
              } else {
                if (agentFlag && !this.props.isAgent && !enFlag) {
                  if (
                    response.data.response.policy &&
                    response.data.response.sharePolicy &&
                    response.data.response.financialPolicy
                  ) {
                    this.setState(
                      {
                        loaderShow: true,
                        count: 4,
                        enrollFlag: enFlag,
                        progress: (4 / 4) * 100,
                      },
                      () => this.getPlanData()
                    );
                  } else {
                    this.setState(
                      {
                        loaderShow: true,
                        enrollFlag: enFlag,
                      },
                      () => this.getPlanData()
                    );
                  }
                } else {
                  if (
                    response.data.response.policy &&
                    response.data.response.sharePolicy &&
                    response.data.response.financialPolicy
                  ) {
                    this.setState({
                      count: 3,
                      submitDone: false,
                      paymentScreenModal: true,
                      enrollFlag: enFlag,
                      loaderShow: false,
                      progress: (3 / 4) * 100,
                    });
                  } else {
                    this.setState({
                      count: 1,
                      submitDone: false,
                      enrollFlag: enFlag,
                      loaderShow: false,
                    });
                  }
                }
              }
            }
            this.getDisabled();
          });
      } else {
        if (enFlag && paymentFlag && !this.props.isAgent && !reenrollmentFlag) {
          this.setState({
            count: 5,
            submitDone: true,
            enrollFlag: enFlag,
            loaderShow: false,
          });
        } else {
          this.setState({
            loaderShow: false,
            count: this.props.agentDetails.clientId == '4599' || this.props.agentDetails.clientId == '5742' ? 0 : 1,
            privacyPolicy: false,
            authorize: false,
            authorize1: false,
            authorize44: false,
            healthTerms: false,
            authorization: false,
            enrollFlag: true,
          });
        }
      }
    
    let subId = JSON.parse(sessionStorage.getItem('STATE_PARAM')).subID ? JSON.parse(sessionStorage.getItem('STATE_PARAM')).subID : JSON.parse(localStorage.getItem('CurrentLoginUser')).id

    if(reenrollmentFlag){
      axios
      .get(
        configuration.baseUrl + "/addon/getReviewChoices/" + subId
      )
      .then(async (response) => {
        const tableData = await this.injectEmployerContribRow(
          response.data.response[0].header,
          subId
        );
        this.setState(
          {
            tableData: tableData,
            popTable: response.data.response[0].popData.header[0],

          },
          () => {
            const id = this.state.popTable.header.indexOf("Surcharge"); // 2
            const removedSurcharge = this.state.popTable.header.splice(id, 1);
            let header = this.state.popTable.header.forEach((e) => {
              return delete e.Surcharge;
            });
            let body = this.state.popTable.body.forEach((e) => {
              delete e.surchargeAmount;
            });
          }
        )
      });
    }
  });
  }

  // Inserts a "Less, Employer Contribution" row into tableData.body
  // above the "Family Total" row, sourcing the amounts from
  // /plan/quoteByPlanSummary's todayPayment / recurringPayment arrays.
  injectEmployerContribRow = async (tableData, subId) => {
    try {
      if (!tableData || !tableData.body || !tableData.header) return tableData;

      const planRes = await fetch(
        configuration.baseUrl + "/plan/quoteByPlanSummary/" + subId
      );
      const planData = await planRes.json();

      const todayEmployer = (planData.todayPayment || []).find(
        (it) => it.text === "Less, Employer Contribution"
      );
      const recurringEmployer = (planData.recurringPayment || []).find(
        (it) => it.text === "Less, Employer Contribution"
      );

      if (!todayEmployer && !recurringEmployer) return tableData;

      // Avoid duplicate insertion if the row is already present
      const alreadyHasRow = tableData.body.some((row) => {
        const firstKey = Object.keys(row)[0];
        return row[firstKey] === "Less, Employer Contribution";
      });
      if (alreadyHasRow) return tableData;

      const familyTotalIdx = tableData.body.findIndex((row) => {
        const firstKey = Object.keys(row)[0];
        return row[firstKey] === "Family Total";
      });
      if (familyTotalIdx === -1) return tableData;

      const headers = tableData.header;
      const newRow = {};
      headers.forEach((header, idx) => {
        const key = typeof header === "string" ? header : String(header);
        if (idx === 0) {
          newRow[key] = "Less, Employer Contribution";
        } else if (idx === 1) {
          newRow[key] = (todayEmployer && todayEmployer.todayAmount) || "-";
        } else if (idx === 2) {
          newRow[key] =
            (recurringEmployer && recurringEmployer.regularAmount) || "-";
        } else {
          newRow[key] = "";
        }
      });
      tableData.body.splice(familyTotalIdx, 0, newRow);
    } catch (err) {
      console.log("Error injecting employer contribution row:", err);
    }
    return tableData;
  };


  toggleCarrierTermAccepted = (termId, forceTrue) => {
    this.setState((prevState) => ({
      termsAccepted: {
        ...prevState.termsAccepted,
        [termId]: forceTrue ? true : !prevState.termsAccepted[termId],
      },
    }), () => this.getDisabled());
  };

  // When an item has a popup (title+body), it can only be *checked* by opening the popup and
  // clicking Accept there — clicking the checkbox/row itself just opens the popup instead of
  // toggling directly. Once already checked, a click there unchecks it directly (no need to
  // re-read to uncheck). Items with no popup toggle directly either way, as before.
  handleTermRowClick = (item, termId) => {
    if (item.title && item.body && !this.state.termsAccepted[termId]) {
      this.setState({ activeTermsPopup: termId });
      return;
    }
    this.toggleCarrierTermAccepted(termId);
  };

  // Items have no id of their own — section + sequence together are stable and unique.
  getConsentItemId = (section, item) => section.section + "-" + item.sequence;

  // Carrier-wise Terms & Conditions content, replacing the old hardcoded termsConfig.js.
  fetchConsentContent = () => {
    let cookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM')) || {};
    let carrierCode = cookiesData.carrier;
    if (!carrierCode) return;
    axios.get(configuration.baseUrl + "/consent/getConsentContent", {
      params: { carrierCode: carrierCode, programType: cookiesData.actionType },
    })
      .then((response) => {
        const sections = (response.data && response.data.response && response.data.response.sections) || [];
        const visibleSections = sections
          .filter((section) => section.flag !== false)
          .slice()
          .sort((a, b) => (a.sequence || 0) - (b.sequence || 0))
          .map((section) => ({
            ...section,
            items: (section.items || [])
              .filter((item) => item.flag !== false)
              .slice()
              .sort((a, b) => (a.sequence || 0) - (b.sequence || 0)),
          }));

        const termsAccepted = {};
        visibleSections.forEach((section) => {
          section.items.forEach((item) => {
            termsAccepted[this.getConsentItemId(section, item)] = false;
          });
        });

        this.setState({ consentSections: visibleSections, consentSectionIndex: 0, termsAccepted }, () => this.getDisabled());
      })
      .catch((error) => console.log(error));
  };

  fetchMemberSSNs = () => {
    let cookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM')) || {};
    let subId = this.props.subId || cookiesData.subID || cookiesData.user_subId;
    let carrierCode = cookiesData.carrier;
    let productType = cookiesData.actionType;
    if (!subId || !carrierCode || !productType) return;
    axios.get(configuration.baseRootUrl + "/veraenroll/api/v1/enrollment/getMemberBySubIdWithSsn/" + subId + "/" + carrierCode + "/" + productType)
      .then((response) => {
        const members = (response.data && response.data.response) || [];
        this.setState({
          memberSSNList: members.map((member) => ({
            id: member.id,
            name: [member.prefix, member.firstName, member.middleName, member.lastName, member.suffix]
              .filter(Boolean)
              .join(' '),
            // The API only ever returns a masked SSN (e.g. "***-**-2323") for privacy — it's shown
            // as the field's placeholder for reference, but never used as an editable value. A
            // member who already hasSsn only needs a new one typed in if it actually needs changing.
            hasSsn: !!member.hasSsn,
            maskedSsn: member.ssn || '',
            memberSsnno: '',
          })),
        }, () => this.getDisabled());
      })
      .catch((error) => console.log(error));
  };

  updateMemberSSNValue = (memberId, value) => {
    const formatted = this.formatSSN(value);
    this.setState((prevState) => ({
      memberSSNList: prevState.memberSSNList.map((member) =>
        member.id === memberId ? { ...member, memberSsnno: formatted } : member
      ),
    }), () => this.getDisabled());
  };

  saveMemberSSNs = () => {
    // Members who already hasSsn have their input disabled (nothing new was — or could be —
    // typed for them), so only members who actually entered a fresh SSN need to be saved.
    const membersToSave = this.state.memberSSNList.filter((member) => !member.hasSsn);
    const advance = () => {
      this.setState({ loaderShow: false, showMemberSSNScreen: false, count: 1, progress: 25 }, () => {
        this.getDisabled();
      });
    };
    if (membersToSave.length === 0) {
      advance();
      return;
    }
    this.setState({ loaderShow: true });
    // Fetch the current RSA public key, encrypt every SSN with it client-side, then post only
    // ciphertext — never the plain SSN — to /ssn/save.
    axios.get(configuration.baseUrl + "/ssn/public-key")
      .then((response) => {
        const publicKey = response.data && response.data.publicKey;
        if (!publicKey) throw new Error("SSN public key missing from response");
        return importSsnPublicKey(publicKey);
      })
      .then((cryptoKey) => Promise.all(
        membersToSave.map((member) =>
          encryptSsn(cryptoKey, member.memberSsnno.replace(/\D/g, "")).then((encryptedSsn) => ({
            memberId: member.id,
            encryptedSsn,
          }))
        )
      ))
      .then((payload) => axios.post(configuration.baseUrl + "/ssn/save", payload))
      .then(advance)
      .catch((error) => {
        console.log(error);
        this.setState({ loaderShow: false });
      });
  };

  // Leading step for the Cognito ENROLL flow: collect/confirm each family member's SSN before
  // moving into the carrier-wise terms screen. Independent of count (see showMemberSSNScreen).
  // Strips non-digits and reinserts dashes as XXX-XX-XXXX, formatting both values fetched
  // from the API (which come back as plain digits, e.g. "9898909") and values as they're typed.
  formatSSN = (raw) => {
    const digits = String(raw || "").replace(/\D/g, "").slice(0, 9);
    return [digits.slice(0, 3), digits.slice(3, 5), digits.slice(5, 9)].filter(Boolean).join("-");
  };

  renderMemberSSNScreen = () => {
    return (
      <Grid item xs={12} style={{ marginTop: "5px", marginBottom: "5px" }}>
        <Typography component="p" style={customeClasses.rowText}>
          Please share the SSN for each family member below. This information is sent directly to your Carrier for processing and is not stored by Vera Benefits.
        </Typography>
        <Grid item xs={12} style={{ marginTop: "20px" }}>
          <Grid container spacing={2}>
            <Grid item xs={3}><b>Family Member</b></Grid>
            <Grid item xs={3}><b>SSN</b></Grid>
          </Grid>
          {this.state.memberSSNList.map((member) => (
            <Grid container spacing={2} key={member.id} style={{ marginTop: "10px", alignItems: "center" }}>
              <Grid item xs={3}>{member.name}</Grid>
              <Grid item xs={3}>
                <input
                  type="text"
                  placeholder={member.hasSsn ? member.maskedSsn : "123-45-6789"}
                  value={this.formatSSN(member.memberSsnno)}
                  onChange={(event) => this.updateMemberSSNValue(member.id, event.target.value)}
                  disabled={member.hasSsn}
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    backgroundColor: member.hasSsn ? "#e8e8e8" : "#f5f5f5",
                    border: "none",
                    borderBottom: "1px solid #b0b0b0",
                    borderRadius: "4px 4px 0 0",
                    padding: "10px 12px",
                    fontSize: "16px",
                    fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                    color: member.hasSsn ? "#7b7b7c" : "#19191d",
                  }}
                />
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    );
  };

  // Carrier-wise Terms & Conditions checkboxes for the Cognito ENROLL flow, driven by
  // /consent/getConsentContent (replaces the old hardcoded termsConfig.js entirely — no
  // static terms content remains here). Each API section is its own step (paginated via
  // consentSectionIndex in increaseProgress/reduceProgress) rather than all sections stacked
  // on one screen. Each item's `text` is HTML with an embedded <a> — a click on that anchor
  // either opens item.link in a new tab (a real downloadable doc), opens the in-app popup
  // (title+body present), or does nothing (neither present); any other click on the row
  // toggles the checkbox.
  renderCarrierWiseTerms = () => {
    const section = this.state.consentSections[this.state.consentSectionIndex];
    if (!section) {
      return <Grid item xs={12} style={{ marginTop: "5px", marginBottom: "5px" }} />;
    }
    const items = section.items.map((item) => ({ item, termId: this.getConsentItemId(section, item) }));

    return (
      <Grid item xs={12} style={{ marginTop: "5px", marginBottom: "5px" }}>
        {this.state.consentSections.length > 1 &&
          <Grid
            item
            xs={12}
            style={{
              fontSize: "12px",
              color: "#5e6f81",
              fontFamily: "Roboto, Arial, Helvetica, sans-serif",
            }}
          >
            Step {this.state.consentSectionIndex + 1} of {this.state.consentSections.length}
          </Grid>
        }
        {section.title &&
          <Grid
            item
            xs={12}
            style={{
              marginTop: "10px",
              marginBottom: "5px",
              fontWeight: "bold",
              fontFamily: "Roboto, Arial, Helvetica, sans-serif",
            }}
          >
            {section.title}
          </Grid>
        }
        {items.map(({ item, termId }) => (
          <Grid item xs={12} key={termId} style={{ marginTop: "5px", marginBottom: "5px" }}>
            <Grid item xs={2}>
              <Checkbox
                checked={!!this.state.termsAccepted[termId]}
                inputProps={{ "aria-label": "secondary checkbox" }}
                style={{ color: "#1a2c40", marginLeft: -12 }}
                onClick={() => this.handleTermRowClick(item, termId)}
              />
            </Grid>
            <Grid
              item
              xs={10}
              style={{
                marginLeft: "25px",
                marginTop: "-36px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
              }}
            >
              <span
                style={{ cursor: "pointer" }}
                onClick={(event) => {
                  if (event.target.tagName === "A") {
                    event.preventDefault();
                    if (item.link) {
                      window.open(item.link, "_blank");
                    } else if (item.title && item.body) {
                      this.setState({ activeTermsPopup: termId });
                    }
                    return;
                  }
                  this.handleTermRowClick(item, termId);
                }}
                dangerouslySetInnerHTML={{ __html: item.text }}
              />
            </Grid>
          </Grid>
        ))}

        {items.filter(({ item }) => item.title && item.body).map(({ item, termId }) => (
          <Modal
            key={"terms-popup-" + termId}
            size={this.state.isMaximized ? null : "lg"}
            show={this.state.activeTermsPopup === termId}
            centered={!this.state.isMaximized}
            onHide={() => this.setState({ activeTermsPopup: null })}
            backdrop="static"
            dialogClassName={this.state.isMaximized ? "modal-fullscreen" : ""}
          >
            <Modal.Header style={customStyle.modal_header} closeButton>
              <Modal.Title>{item.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: this.state.isMaximized ? "100vh" : "450px",
                overflowY: "auto",
                textAlign: "justify",
                wordSpacing: "-2px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "15px",
              }}
            >
              <div dangerouslySetInnerHTML={{ __html: item.body }} />
              <div className="text-right" style={{ marginTop: "15px" }}>
                <CustomeButton
                  onClick={() => this.setState({ activeTermsPopup: null })}
                  style={{ marginRight: "24px", padding: "11px 20px", lineHeight: "normal" }}
                >
                  {i18n.t("BUTTON.CANCEL")}
                </CustomeButton>
                <CustomeButton
                  onClick={() => {
                    this.toggleCarrierTermAccepted(termId, true);
                    this.setState({ activeTermsPopup: null });
                  }}
                  style={{ padding: "11px 20px", lineHeight: "normal" }}
                >
                  {i18n.t("BUTTON.ACCEPT")}
                </CustomeButton>
              </div>
            </Modal.Body>
          </Modal>
        ))}
      </Grid>
    );
  };

  getPlanData = () => {
    let planDataCookiesData = JSON.parse(sessionStorage.getItem('STATE_PARAM')) || {};
    let planDataProductType = planDataCookiesData.actionType;
    fetch(configuration.baseUrl + "/plan/getMemberPlan/" + this.props.subId + '/' + planDataProductType)
      .then((selectedPlan) => selectedPlan.json())
      .then((selectedPlan) => {
        let sharingPlan = selectedPlan.response.planId;
        let selectedPlanCode = selectedPlan.response.planCode;

        // Replaces /plan/quoteByPlanSummary - the review-choices endpoint used
        // elsewhere in this file, keyed off the same cookiesData
        // carrier/brokerId/productType.
        let subId = this.props.subId || planDataCookiesData.subID || planDataCookiesData.user_subId;
        let brokerId = planDataCookiesData.brokerId;
        let carrier = planDataCookiesData.carrier;
        axios.get(configuration.baseRootUrl + '/veraenroll/api/v1/quote/review-choices/' + subId + '/' + carrier + '/' + brokerId + `?productType=${planDataProductType}`)
          .then((response) => {
            let familyBreakdown = response.data.familyBreakdown || {};
            let familyRows = familyBreakdown.rows || [];
            // Last row is the "Family Total" entry - its own `total` is already
            // amount + surcharge combined, same as the old amount+surcharge sum.
            let familyTotalRow = familyRows[familyRows.length - 1];
            let totalCost = familyTotalRow
              ? parseFloat(String(familyTotalRow.total).replace(/[^0-9.-]/g, "")) || 0
              : 0;

            this.setState({
              planFamilyDetails: familyRows,
              headerData: familyBreakdown.header,
              loaderShow: false,
              totalCost: totalCost.toFixed(2),
              sharingPlan: sharingPlan,
              selectedPlanCode: selectedPlanCode,
            });
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  viewPlanHideModalHealth = (event) => {
    this.setState(
      {
        modalShow: false,
        healthTerms: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  viewPlanHideModalHealth11 = (event) => {
    this.setState({
      modalShow: false,
      healthTerms: false,
    });
  };

  viewPlanHideModalHealth1 = (event) => {
    if (this.state.healthTerms == false) {
      this.setState(
        {
          modalShow: false,
          healthTerms: false,
        },
        () => {
          this.getDisabled();
        }
      );
    } else {
      this.setState(
        {
          modalShow: false,
          healthTerms: true,
        },
        () => {
          this.getDisabled();
        }
      );
    }
  };

  showPlansModalHealth = (event) => {
    this.setState(
      {
        modalShow: true,
      },
      () => {
        this.getDisabled();
      }
    );
  };

  handleClose = (event) => {
    sessionStorage.setItem("current_screen", String(this.props.activeStep));

    let currentScreen = sessionStorage.getItem("current_screen");

    if (this.props.isAgent) {
      axios
        .get(
          configuration.baseUrl +
            "/enrollment/saveCompletionStatus/" +
            this.props.subId +
            "/" +
            currentScreen
        )
        .then((response) => {
          if (response && response.data.code === 200) {
            sessionStorage.removeItem("STATE_PARAM");
            sessionStorage.removeItem("STATE_VAL");
            sessionStorage.removeItem("CLIENT_ID");
            sessionStorage.removeItem("CHAT_BOX_Id");
            cookies.remove("STATE_PARAM", { path: "/" });
            window.close();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      this.setState({
        successModal: false,
      });
    }
  };

  handlerCopy(e) {
    e.preventDefault();
  }

  getDisabled = () => {
    if (this.props.enrollingStepperType && this.state.showMemberSSNScreen) {
      const members = this.state.memberSSNList;
      // A member who already hasSsn is already complete — a new one only needs to be typed if
      // it's actually changing, since the API never gives back a usable, unmasked value to keep.
      const allComplete = members.length > 0 && members.every((member) => member.hasSsn || this.formatSSN(member.memberSsnno).replace(/\D/g, "").length === 9);
      this.setState({ nextDisabled: !allComplete, isMaximized: false });
      return;
    }
    if(this.state.count === 0){
      if(this.state.frontCard && this.state.backCard){
        this.setState({
          nextDisabled: false,
          isMaximized: false
        });
      }else{
        this.setState({
          nextDisabled: true,
          isMaximized: false
        });
      }
    }
    if (this.state.count === 1) {
      if (this.props.enrollingStepperType) {
        // NEXT only requires the section currently on screen — not every section across
        // the whole terms flow — since each section is its own step.
        const currentSection = this.state.consentSections[this.state.consentSectionIndex];
        const termIds = currentSection
          ? currentSection.items.map((item) => this.getConsentItemId(currentSection, item))
          : [];
        const allAccepted = termIds.length > 0 && termIds.every((termId) => this.state.termsAccepted[termId]);
        this.setState({
          nextDisabled: !allAccepted,
          isMaximized: false
        });
      } else if (
        this.state.privacyPolicy &&
        this.state.authorize &&
        this.state.authorize1
      ) {
        /* this.state.authorize44 */
        this.setState({
          nextDisabled: false,
          isMaximized: false
        });
      } else {
        this.setState({
          nextDisabled: true,
          isMaximized: false
        });
      }
    } else if (this.state.count === 2) {
      this.setState({
        nextDisabled: !this.state.authorization,
        isMaximized: false
      });
    } else if (this.state.count === 3) {
      this.setState({
        nextDisabled: !this.state.healthTerms,
        isMaximized: false
      });
    } else if (this.state.count === 4) {
      this.setState({
        nextDisabled: true,
        isMaximized: false
      });
    }
  };

  handleLogout = () => {
    this.setState({
      loaderShow: true,
    });

    let currentScreen = sessionStorage.getItem("current_screen");

    axios
      .get(
        configuration.baseUrl +
          "/enrollment/saveCompletionStatus/" +
          this.props.subId +
          "/" +
          currentScreen
      )
      .then((response) => {
        if (response && response.data.code === 200) {
          Auth.signOut();
          localStorage.clear();
          sessionStorage.clear();
          localStorage.setItem("isLogged", false);
          sessionStorage.setItem("isLogged", false);
          // cookies.remove("STATE_PARAM", { path: "/" });
          window.location.href = "/login";
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Entry point for both "SEND AUTH EMAIL" and "SEND AUTH TEXT" — always confirms/updates the
  // prospect's contact details first (Contact Update modal), then hands off to the pre-existing
  // send-authorization flow below with whichever email/phone the agent confirmed.
  getEmailPhoneDetails = (requestType) => {
    let CurrentLoginUser = JSON.parse(localStorage.getItem("CurrentLoginUser")) || {};
    let currentEmail = CurrentLoginUser.email || "";
    let currentFullPhone = CurrentLoginUser.phone || "";
    // CurrentLoginUser.phone is stored with its country code baked in (e.g. "+17057455568") —
    // same length-based split goToAgentDashboard's sms branch already uses ("+91" is 3 chars,
    // everything else assumed "+1") — so the field below can show/edit just the bare 10 digits.
    let countryCode = "+1";
    let barePhone = "";
    if (currentFullPhone) {
      if (currentFullPhone.length === 13) {
        countryCode = currentFullPhone.substr(0, 3);
        barePhone = currentFullPhone.substr(3);
      } else {
        countryCode = currentFullPhone.substr(0, 2);
        barePhone = currentFullPhone.substr(2);
      }
    }
    this.setState({
      contactUpdateModal: true,
      contactUpdateEmail: currentEmail,
      contactUpdatePhone: barePhone,
      contactUpdateCountryCode: countryCode,
      contactUpdateOriginalEmail: currentEmail,
      contactUpdateOriginalPhone: barePhone,
      pendingRequestType: requestType,
    });
  };

  // Called from the Contact Update modal's SAVE button — only hits updateContactInfo when the
  // agent actually changed something, then continues into the original getEmailPhoneDetails flow.
  confirmContactUpdate = () => {
    let requestType = this.state.pendingRequestType;
    let email = this.state.contactUpdateEmail;
    let fullPhone = this.state.contactUpdateCountryCode + this.state.contactUpdatePhone;
    let changed =
      email !== this.state.contactUpdateOriginalEmail ||
      this.state.contactUpdatePhone !== this.state.contactUpdateOriginalPhone;

    let proceed = () => {
      let CurrentLoginUser = JSON.parse(localStorage.getItem("CurrentLoginUser")) || {};
      CurrentLoginUser.email = email;
      CurrentLoginUser.phone = fullPhone;
      localStorage.setItem("CurrentLoginUser", JSON.stringify(CurrentLoginUser));
      // sendAuthRequest reads this.state.email (not CurrentLoginUser) — keep it in sync so a
      // changed email here actually reaches the auth request instead of using the stale,
      // mount-time value.
      this.setState({ contactUpdateModal: false, loaderShow: false, email: email }, () => {
        this.continueAfterContactConfirm(requestType);
      });
    };

    if (!changed) {
      proceed();
      return;
    }

    let cookiesData = JSON.parse(sessionStorage.getItem("STATE_PARAM")) || {};
    this.setState({ loaderShow: true });
    axios
      .post(configuration.baseRootUrl + "/veraenroll/api/v1/setupfamily/updateContactInfo", {
        subId: cookiesData.subID,
        email: email,
        phone: fullPhone,
      })
      .then(() => {
        proceed();
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loaderShow: false });
      });
  };

  // The Contact Update modal (see getEmailPhoneDetails/confirmContactUpdate) already collected
  // and confirmed both email and phone before this runs, so there's nothing left to check or
  // re-confirm here — just proceed straight to sending the authorization request.
  continueAfterContactConfirm = (requestType) => {
    this.goToAgentDashboard(requestType);
  };

  getInviteStatus = (requestType, phone) => {
    axios
      .get(
        configuration.baseUrl +
          "/setupfamily/getMemberBySubID/" +
          this.props.subId
      )
      .then((response) => {
        if (response.data.response) {
          let data = JSON.parse(JSON.stringify(response.data.response));
          console.log("---Invite status---", data.inviteStatus);
          this.setState(
            {
              inviteStatus:
                data.inviteStatus != null
                  ? moment(data.inviteStatus).format("DD MMM YYYY hh:mm a")
                  : null,
              reqType: requestType,
              phoneNumber: phone,
              loaderShow: false,
            },
            () => {
              if (this.state.inviteStatus == null) {
                this.sendAuthRequest(requestType, phone);
              } else {
                this.setState({
                  loaderShow: false,
                  inviteStatusModal: true,
                });
              }
            }
          );
        }
      });
  };

  closeInviteStatusModal = () => {
    this.setState(
      {
        inviteStatusModal: false,
        inviteStatus: "",
      },
      () => this.handleClose()
    );
  };

  // Email/phone are already confirmed (Contact Update modal ran before this was called) — no
  // more per-request-type branching into a re-confirmation popup, just check invite status and
  // send using CurrentLoginUser's (just-confirmed) contact details.
  goToAgentDashboard = (requestType) => {
    this.setState({
      loaderShow: true,
      paymentScreenModal: false,
    });
    let CurrentLoginUser = JSON.parse(localStorage.getItem("CurrentLoginUser"));
    if (this.state.inviteStatusFlag == false) {
      this.getInviteStatus(requestType, CurrentLoginUser.phone);
    } else {
      this.sendAuthRequest(requestType, CurrentLoginUser.phone);
    }
  };

  handleDateChange = (date, didMount) => {
    this.setState(
      {
        targetDate: date,
      },
      () => {
        let panel = document.getElementById("date-picker-dialog");
        panel.addEventListener("onmouseleave", function () {
          document.getElementById("date-picker-dialog-label").style.paddingTop =
            "10px";
        });
      }
    );
  };

  sendAuthRequest = (requestType, phoneNumber) => {
    axios
      .get(
        configuration.baseUrl +
          "/enrollment/registration/" +
          this.state.email.toLowerCase() +
          "/" +
          phoneNumber +
          "/" +
          requestType +"?carrierCode="+this.state.carrierCode
      ) //this.props.email
      .then((response) => {
        if (response && response.data.code === 200) {
          this.setState({
            loaderShow: false,
            successModal: true,
            inviteStatusModal: false,
            inviteStatus: "",
            popUpMsg:
              requestType === "sms"
                ? "E-Signature SMS sent successfully!"
                : "E-Signature mail sent successfully!",
          });
        } else if (response.data.code === 202) {
          this.setState({
            loaderShow: false,
            successModal: true,
            inviteStatusModal: false,
            inviteStatus: "",
            popUpMsg:    requestType === "sms"
            ? "The E-Signature SMS was RESENT!" : "E-Signature mail sent successfully!",
          });
        } else if (response.data.code === 204) {
          this.setState({
            loaderShow: false,
            successModal: true,
            inviteStatusModal: false,
            inviteStatus: "",
            popUpMsg:
              requestType === "sms"
                ? "The E-Signature SMS was RESENT!"
                : "The E-Signature email was RESENT!",
          });
        } else if (response.data.code === 409) {
          this.setState({
            loaderShow: false,
            successModal: true,
            inviteStatusModal: false,
            inviteStatus: "",
            popUpMsg: "User already exists in the given User Pool.",
          });
        } else if (response.data.code === 500) {
          this.setState({
            loaderShow: false,
            successModal: true,
            inviteStatusModal: false,
            inviteStatus: "",
            popUpMsg:
              "Oops! Something's not right. If you're still having trouble, call us on (800) 921-4505",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        console.log(error.response);
        if (error.response.status === 500) {
          this.setState({
            loaderShow: false,
            successModal: true,
            popUpMsg:
              "Oops! Something's not right. If you're still having trouble, call us on (800) 921-4505",
          });
        }
      });
  };

  handleBack = () => {
    this.setState(
      {
        paymentScreenModal: false,
      },
      () => {
        this.props.handlePrev();
      }
    );
  };

  handleReenrollClose = () => {
    this.handleLogout();
    window.close();
  };

  checkSubmitButtonDisabled = () => {
    if (this.state.count <= 4) {
      return true;
    } else {
      if (this.state.fullName === "") {
        return true;
      } else {
        if (this.state.signType !== "stylized") {
          if (!this.state.canvasDone) {
            return true;
          }
        }
      }
    }
    return false;
  };

  handleButtonClick = (side) => {
    this.fileInputRef.current.click();
    this.setState({ currentSide: side });
  };

  handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    const validExtensions = ['image/jpeg', 'image/png'];
    if (!selectedFile.type.startsWith('image/')) {
      this.setState({ error: 'Please select an image file.' });
      return;
    }else if(!validExtensions.includes(selectedFile.type)){
      this.setState({ error: 'File type not supported. Please upload a JPEG or PNG image.' });
      return;
    }
    // Clear error if image file is selected
    this.setState({ error: '' });
    // Do something with the selected file
    console.log('Selected file:', selectedFile);
    if (this.state.currentSide === 'front') {
      this.setState({ frontCard: selectedFile,msg:'File uploaded successfully'},
      ()=>{this.getDisabled();
        setTimeout(() => {
          this.setState({ showMessage: false }, () => {
            // Clear the message after the transition
            setTimeout(() => {
              this.setState({ msg: '' });
            }, 500); // The duration of the fade-out transition
          });
        }, 3000); // 3000 milliseconds = 3 seconds
      });
    } else if (this.state.currentSide === 'back') {
      this.setState({ backCard: selectedFile,msg:'File uploaded successfully'}, 
      ()=>{this.getDisabled();
        setTimeout(() => {
          this.setState({ showMessage: false }, () => {
            // Clear the message after the transition
            setTimeout(() => {
              this.setState({ msg: '' });
            }, 500); // The duration of the fade-out transition
          });
        }, 3000); // 3000 milliseconds = 3 seconds
    });
    }
    
  };

  render() {
    console.log('---- -- ', this.state.count
    , ' ==  ', this.state.fromMember);
    const { classes } = this.props;
    let currentScreen = "";
    let myDate =
      moment(this.state.targetDate).format("MM") +
      "/" +
      moment(this.state.targetDate).format("DD") +
      "/" +
      moment(this.state.targetDate).format("YYYY");
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    let futureTomarow = new Date(today);
    let futureDate;
    if (
      this.state.clientId === "6548" ||
      this.state.clientId === "4367" ||
      this.state.clientId === "5540" ||
      this.state.clientId === "5647" ||
      this.state.clientId === "5541" ||
      this.state.clientId === "4377" ||
      this.state.clientId === "5558" ||
      this.state.clientId === "4386" || 
      this.state.clientId === "5696" ||
      this.state.clientId === "4397" || 
      this.state.clientId === "5596" || 
      this.state.clientId === "4390" 
    ) {
      if (new Date() < new Date("05/01/2021")) {
        if (new Date() < new Date(this.state.empEffectiveDate)) {
          let efectiveDate = new Date(this.state.empEffectiveDate);
          let effectiveDay = new Date(this.state.empEffectiveDate).getDate();
          if (effectiveDay === 1 || effectiveDay > 1) {
            tomorrow.setDate(1);
            tomorrow.setMonth(new Date(efectiveDate).getMonth() + 1);

            futureTomarow.setDate(1);
            futureTomarow.setMonth(new Date(efectiveDate).getMonth() + 1);
          }
        } else {
          tomorrow.setDate(1);
          tomorrow.setMonth(4);
          futureTomarow.setDate(1);
          futureTomarow.setMonth(4);
        }
      } else if (new Date().getDate() === 1 || new Date().getDate() > 1) {
        if (new Date() < new Date(this.state.empEffectiveDate)) {
          let efectiveDate = new Date(this.state.empEffectiveDate);
          let effectiveDay = new Date(this.state.empEffectiveDate).getDate();
          if (effectiveDay === 1 || effectiveDay > 1) {
            tomorrow.setDate(1);
            tomorrow.setMonth(new Date(efectiveDate).getMonth() + 1);

            futureTomarow.setDate(1);
            futureTomarow.setMonth(new Date(efectiveDate).getMonth() + 1);
          }
        } else {
          tomorrow.setDate(1);
          tomorrow.setMonth(today.getMonth() + 1);
          futureTomarow.setDate(1);
          futureTomarow.setMonth(today.getMonth() + 1);
        }
      }
      futureDate = futureTomarow.setDate(futureTomarow.getDate() + 45);
    } else {
      futureDate = futureTomarow.setDate(futureTomarow.getDate() + 90);
    }

    if(this.state.count === 0){
      currentScreen = (
        <Grid item xs={12} style={{ marginTop: "5px", marginBottom: "5px" }}>
          
            </Grid>
      )
    }
    if (this.props.enrollingStepperType && this.state.showMemberSSNScreen) {
      currentScreen = this.renderMemberSSNScreen();
    }
    else if(this.props.isAgent){
      currentScreen = (
        <Grid item xs={12} style={{ marginTop: "5px", marginBottom: "5px" }}>

        </Grid>)
    }
    else if (this.state.count === 1) {
      currentScreen = this.props.enrollingStepperType ? this.renderCarrierWiseTerms() : (
        <Grid item xs={12} style={{ marginTop: "5px", marginBottom: "5px" }}>
          <Grid item xs={12} style={{ marginTop: "5px" }} id="11">
            <Grid item xs={2}>
              <Checkbox
                checked={this.state.privacyPolicy}
                inputProps={{
                  "aria-label": "secondary checkbox",
                }}
                style={{ color: "#1a2c40", marginLeft: -12 }}
                onClick={this.showPlansModalPrivacy}
              />
            </Grid>
            <Grid
              item
              xs={10}
              style={{
                marginLeft: "25px",
                marginTop: "-36px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
              }}
            >
              <span
                style={{
                  cursor: "pointer",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
                onClick={this.showPlansModalPrivacy}
              >
                {i18n.t("SUBMIT_APPLICATION.AGREE")}{" "}
                <span
                  style={{
                    color: "#1a2c40",
                    cursor: "pointer",
                    fontWeight: "bold",
                    borderBottom: "1px solid #1a2c40",
                  }}
                  onClick={this.showPlansModalPrivacy}
                >
                  {i18n.t("SUBMIT_APPLICATION.PRIVACY")}
                </span>
              </span>
            </Grid>
          </Grid>

          <Grid item xs={12} id="12">
            <Grid item xs={2}>
              <Checkbox
                checked={this.state.authorize1}
                inputProps={{
                  "aria-label": "secondary checkbox",
                }}
                style={{ color: "#1a2c40", marginLeft: -12 }}
                onClick={this.showAuthorizeModalPopup2}
              />
            </Grid>
            <Grid
              item
              xs={10}
              style={{
                marginLeft: "25px",
                marginTop: "-36px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
              }}
            >
              <span
                style={{ cursor: "pointer" }}
                onClick={this.showAuthorizeModalPopup2}
              >
                {i18n.t("SUBMIT_APPLICATION.AUTHORIZE2")}
                <span
                  style={{
                    color: "#1a2c40",
                    cursor: "pointer",
                    fontWeight: "bold",
                    borderBottom: "1px solid #1a2c40",
                  }}
                  onClick={this.showAuthorizeModalPopup2}
                >
                  {i18n.t("SUBMIT_APPLICATION.AUTHORIZE22")}
                </span>
              </span>
            </Grid>
          </Grid>

          <Grid item xs={12} style={{ marginBottom: "5px" }} id="13">
            <Grid item xs={2}>
              <Checkbox
                checked={this.state.authorize}
                inputProps={{
                  "aria-label": "secondary checkbox",
                }}
                style={{ color: "#1a2c40", marginLeft: -12 }}
                onClick={this.checkFellowshipStatus}
              />
            </Grid>
            <Grid
              item
              xs={10}
              style={{
                marginLeft: "25px",
                marginTop: "-36px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
              }}
            >
              <span style={{ cursor: "pointer" }}
              onClick={this.showAuthorizeModalPopup3}
              >
                {i18n.t("SUBMIT_APPLICATION.TELEPHONE_TEXT")}
                {/* <span
                  style={{
                    color: "#1a2c40",
                    cursor: "pointer",
                    fontWeight: "bold",
                    borderBottom: "1px solid #1a2c40",
                  }}
                  onClick={this.showAuthorizeModalPopup3}
                >
                  {i18n.t("SUBMIT_APPLICATION.FELLOWSHIPTEXT")}
                </span> */}
              </span>
            </Grid>
          </Grid>

          <Modal
            size={this.state.isMaximized ? null : "lg"}
            show={this.state.modalShowPrivacy}
            centered={!this.state.isMaximized}
            onHide={(event) => this.hideModalPrivacy11(event)}
            backdrop="static"
            dialogClassName={this.state.isMaximized ? "modal-fullscreen" : ""}
          >
            <Modal.Header style={customStyle.modal_header}>
              <Modal.Title>
                {i18n.t("SUBMIT_APPLICATION.PRIVACY_TITLE")}
              </Modal.Title>
              <Grid item xs={2} sm={2} md={2} lg={2} style={{ display: "flex" }}>
                <Button
                    variant="light"
                    style={{ marginLeft: 'auto', visibility: "hidden" }}
                    onClick={this.toggleMaximize}
                >
                    {this.state.isMaximized ?
                        <FullscreenExitIcon />
                        :
                        <FullscreenIcon />
                    }
                </Button>
                <Button onClick={(event) => this.hideModalPrivacy11(event)}>
                    <CloseIcon />
                </Button>
            </Grid>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: this.state.isMaximized ? "100vh" : "450px",
                overflowY: "auto",
                textAlign: "justify",
                wordSpacing: "-2px",
                overflowX: "none",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "15px",
              }}
            >
              {/* {this.state.loaderShow ? <Loader></Loader> : ""} */}
              <div dangerouslySetInnerHTML={{
                __html: `
                  <h1 style="font-size:16pt;text-align:center;margin:0 0 12pt; color:#000000"><b>Privacy Policy</b></h1>
                  <p style="margin:0 0 8pt;text-align:center; color:#595959">Universal Health Fellowship, Inc.&nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;Effective Date: July 21, 2026</p>
                  <p style="font-size:11pt; margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">Universal Health Fellowship, Inc. (“UHF,” “we,” “us,” or “our”) respects the privacy of our members, program participants, website visitors, agents, providers, and other individuals who interact with us. This Privacy Policy describes the personal information we collect, how we use and share it, the choices you have, and your rights under applicable law.</p>
                  <p style="font-size:11pt; margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">This Policy applies to UHF websites, member and agent portals, mobile and web applications, and other services that link to it (collectively, the “Services”). Where we provide a supplemental or program-specific privacy notice, the more specific notice controls for that program.</p>
                  <h2 style="font-size:13pt; margin:12pt 0 6pt; color:#253760; font-weight:bold">An Important Note About Health Care Sharing</h2>
                  <p style="font-size:11pt; margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">UHF facilitates a health care cost-sharing program in which members voluntarily share one another’s eligible medical expenses. UHF is not an insurance company, and membership is not insurance. A health care sharing ministry is generally not a “covered entity” under HIPAA, so the HIPAA rules that apply to insurers and health care providers generally do not apply to UHF. We nevertheless recognize that the information members share with us — including information about medical needs and conditions — is sensitive, and we protect it as described in this Policy and handle it only as needed to administer the sharing program.</p>
                  <h2 style="font-size:13pt; margin:12pt 0 6pt; color:#253760; font-weight:bold">Information We Collect</h2>
                  <p style="font-size:11pt; margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">We collect personal information directly from you, automatically through your use of the Services, and from third parties such as agents, brokers, providers, and service partners. Depending on how you interact with us, this may include:</p>
                  <ul style="margin:0 0 8pt; padding-left:40px;text-align:left">
                    <li style="font-size:11pt; margin-bottom:1pt; line-height: 1.3; color:#000000"><strong>Identifiers and contact details —</strong> name, mailing address, email address, telephone number, and account or membership identifiers.</li>
                    <li style="font-size:11pt; margin-bottom:1pt; line-height: 1.3; color:#000000"><strong>Enrollment and membership information —</strong> program selected, membership status, dependents or household members, and eligibility information.</li>
                    <li style="font-size:11pt; margin-bottom:1pt; line-height: 1.3; color:#000000"><strong>Health-related information —</strong> medical needs, conditions, treatment, and expense information submitted in connection with sharing requests, collected only as needed to administer the sharing program.</li>
                    <li style="font-size:11pt; margin-bottom:1pt; line-height: 1.3; color:#000000"><strong>Financial and payment information —</strong> billing details, contribution and payment history, and bank or card information used to process payments.</li>
                    <li style="font-size:11pt; margin-bottom:1pt; line-height: 1.3; color:#000000"><strong>Communications —</strong> records of your communications with us, including customer support interactions.</li>
                    <li style="font-size:11pt; margin-bottom:1pt; line-height: 1.3; color:#000000"><strong>Automatically collected information —</strong> IP address, device and browser information, login activity, and usage information collected through cookies and similar technologies (see “Cookies and Tracking Technologies”).</li>
                  </ul>
                  <h2 style="font-size:13pt;margin:12pt 0 6pt; color:#253760; font-weight:bold">How We Use Personal Information</h2>
                  <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">We use personal information to operate our organization and administer the sharing program, including to: enroll members and administer memberships and eligibility; process, review, and facilitate the sharing of eligible medical expenses; process contributions, payments, and billing; provide customer support; communicate with you about your membership, including account, billing, security, and operational notices; send newsletters and marketing communications where permitted (see “Your Marketing Choices”); maintain security and prevent fraud; conduct analytics and improve our programs and Services; and comply with law and enforce our agreements.</p>
                  <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">We process personal information as necessary to provide the Services you request, to pursue our legitimate organizational interests consistent with your rights, to comply with legal obligations, and, where required, with your consent.</p>
                  <h2 style="font-size:13pt;margin:12pt 0 6pt; color:#253760; font-weight:bold">Cookies and Tracking Technologies</h2>
                  <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">Our websites and applications use cookies and similar technologies to operate the site, remember your preferences, understand how visitors use our web properties, and improve your experience. You can control cookies through your browser settings. Where required by law, we honor recognized browser-based opt-out preference signals (such as Global Privacy Control) as a request to opt out of the sale or sharing of personal information and targeted advertising. Disabling some cookies may affect functionality. We do not use advertising or analytics cookies on pages where members submit health-related information.</p>
                  <h2 style="font-size:13pt;margin:12pt 0 6pt; color:#253760; font-weight:bold">How We Share Personal Information</h2>
                  <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">We do not sell your personal information for money, and we do not “sell” or “share” it for cross-context behavioral advertising as those terms are defined under applicable state privacy laws. We share personal information only as follows:</p> 
                  <ul style="margin:0 0 8pt;padding-left:40px;text-align:left">
                    <li style="font-size:11pt; margin-bottom:1pt; line-height: 1.3; color:#000000""><strong>Service providers —</strong> with vendors who perform services on our behalf, such as cloud hosting (including Amazon Web Services), payment processing, communications delivery, medical-expense review, customer support, and analytics. They may use the information only to perform services for us and are bound by contractual confidentiality and data-protection obligations.</li>
                    <li style="font-size:11pt; margin-bottom:1pt; line-height: 1.3; color:#000000""><strong>Within our organization —</strong> with UHF affiliates and authorized personnel who need the information to perform their roles.</li>
                    <li style="font-size:11pt; margin-bottom:1pt; line-height: 1.3; color:#000000""><strong>Professional advisors —</strong> with our attorneys, auditors, accountants, and insurers as needed to operate our organization.   </li>
                    <li style="font-size:11pt; margin-bottom:1pt; line-height: 1.3; color:#000000""><strong>Legal and safety —</strong> with government agencies, law enforcement, or others when we believe in good faith that disclosure is required by law or legal process, or necessary to prevent harm, protect rights or safety, or investigate suspected fraud or unlawful activity.</li>
                    <li style="font-size:11pt; margin-bottom:1pt; line-height: 1.3; color:#000000""><strong>Business transfers —</strong> with parties involved in a merger, acquisition, financing, reorganization, or sale or transfer of assets; any successor remains bound by this Policy or must provide notice of material changes.</li>
                  </ul>
                  <h2 style="font-size:13pt;margin:12pt 0 6pt; color:#253760; font-weight:bold">How We Protect Personal Information</h2>
                  <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">We maintain reasonable administrative, technical, and physical safeguards designed to protect personal information against loss, misuse, and unauthorized access, disclosure, alteration, or destruction, including encryption of personal information in transit and at rest, access controls, and monitoring. We limit access to authorized personnel and service providers who need it to perform their functions. No method of transmission or storage is completely secure, and we cannot guarantee absolute security; if a security incident affects your personal information, we will notify you and applicable regulators as required by law.</p>
                  <h2 style="font-size:13pt;margin:12pt 0 6pt; color:#253760; font-weight:bold">How Long We Retain Personal Information</h2>
                  <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">We retain personal information only as long as necessary to fulfill the purposes for which it was collected, to administer memberships and resolve disputes, and to comply with legal, accounting, and regulatory obligations. When it is no longer needed, we securely delete or de-identify it.</p>
                  <h2 style="font-size:13pt;margin:12pt 0 6pt; color:#253760; font-weight:bold">Your Privacy Rights</h2>
                  <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">Depending on where you live, you may have some or all of the following rights: to confirm whether we process your personal information and to access it; to receive a copy in a portable format; to correct inaccuracies; to request deletion; to opt out of the sale or sharing of personal information, targeted advertising, and certain profiling; and to appeal a denial of your request. Certain state laws also provide additional consent and access rights for consumer health data; where they apply, we honor them. We will not discriminate against you for exercising your rights.</p>
                  <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">To submit a request, contact us at <a href="mailto:info@UniversalHealthFellowship.org" style="color:#1a2c40">info@UniversalHealthFellowship.org</a> or (888) 636-7119. We will verify your request as required by law and respond within the timeframes applicable in your state. You may use an authorized agent where permitted; we may require verification of the agent’s authority.</p>
                  <h2 style="font-size:13pt;margin:12pt 0 6pt; color:#253760; font-weight:bold">Your Marketing Choices</h2>
                  <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">We send marketing communications only where permitted by law, and marketing consent is never a condition of membership. You may opt out of marketing emails via the “Unsubscribe” link or by contacting us at <a href="mailto:info@UniversalHealthFellowship.org" style="color:#1a2c40">info@UniversalHealthFellowship.org</a>, and opt out of marketing texts by replying STOP. Opting out of marketing does not affect transactional or service messages relating to your membership.</p>
                  <h2 style="font-size:13pt;margin:12pt 0 6pt; color:#253760; font-weight:bold">Individuals Outside the United States</h2>
                  <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">UHF is based in the United States, and our programs and Services are intended only for individuals located in the United States. We do not offer our programs to, or knowingly collect personal information from, individuals outside the United States; if we learn we have inadvertently done so, we will take reasonable steps to delete the information.</p>
                  <h2 style="font-size:13pt;margin:12pt 0 6pt; color:#253760; font-weight:bold">Children’s Privacy</h2>
                  <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">Our Services are intended for adults and are not directed to children under 13, and we do not knowingly collect personal information directly from children under 13. Where a membership includes minor dependents, we collect their information from the enrolling adult member and use it only to administer the membership. If you believe we have collected information directly from a child under 13, please contact us so we can delete it.</p>
                  <h2 style="font-size:13pt;margin:12pt 0 6pt; color:#253760; font-weight:bold">Links to Other Websites</h2>
                  <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">Our Services may link to third-party websites we do not control. We are not responsible for their privacy practices or content, and we encourage you to review their privacy notices.</p>
                  <h2 style="font-size:13pt;margin:12pt 0 6pt; color:#253760; font-weight:bold">Changes to This Privacy Policy</h2>
                  <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">We may update this Privacy Policy from time to time. When we do, we will revise the Effective Date above and post the updated Policy. For material changes, we will provide advance notice by email or prominent notice within the Services before the changes take effect.</p>
                  <h2 style="font-size:13pt;margin:12pt 0 6pt; color:#253760; font-weight:bold">How to Contact Us</h2>
                  <p style="font-size:11pt;margin:0 0 8pt;text-align:left; color:#000000;line-height:1.3">If you have questions about this Privacy Policy or our privacy practices, or wish to exercise your rights, contact: Universal Health Fellowship, Inc., Attn: Privacy Administrator, 4555 Mansell Road, Suite 300, Alpharetta, GA 30022 • <a href="mailto:info@UniversalHealthFellowship.org" style="color:#1a2c40">info@UniversalHealthFellowship.org</a> • (888) 636-7119 • <a href="https://universalhealthfellowship.org/" target="_blank" rel="noopener noreferrer" style="color:#1a2c40">www.UniversalHealthFellowship.org</a></p>
                  
                `
              }} />
              <div className="text-right" style={{ marginTop: "15px" }}>
                  <CustomeButton
                    onClick={(event) => this.hideModalPrivacy(event)}
                    style={{ marginRight: "24px", padding: "11px 20px", lineHeight: "normal" }}
                  >
                    {i18n.t("BUTTON.CANCEL")}
                  </CustomeButton>
                  <CustomeButton onClick={() => this.acceptPrivacyPolicy()} style={{ padding: "11px 20px", lineHeight: "normal" }}>
                    {i18n.t("BUTTON.ACCEPT")}
                  </CustomeButton>
                </div>
            </Modal.Body>
          </Modal>

          <Modal
            size={this.state.isMaximized ? null : "lg"}
            show={this.state.authModalShow3}
            centered={!this.state.isMaximized}
            onHide={(event) => this.authorizeHideModal3(event)}
            backdrop="static"
            dialogClassName={this.state.isMaximized ? "modal-fullscreen" : ""}
          >
            <Modal.Header style={customStyle.modal_header} closeButton>
              <Modal.Title>
                {i18n.t("SUBMIT_APPLICATION.TELEPHONE_TITLE")}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: this.state.isMaximized ? "100vh" : "450px",
                overflowY: "auto",
                textAlign: "justify",
                wordSpacing: "-2px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "15px",
              }}
            >
              <>
              <div style={{ paddingTop: "8px" }}>
                {i18n.t("SUBMIT_APPLICATION.TELEPHONE_TEXT")}
              </div>
              <div style={{ paddingTop: "8px" }}>
                {i18n.t("SUBMIT_APPLICATION.TELEPHONE_TEXT1")}
              </div>
              <div style={{ paddingTop: "8px" }}>
                {i18n.t("SUBMIT_APPLICATION.TELEPHONE_TEXT2")}
              </div>
              <div className="text-right" style={{ marginTop: "15px" }}>
                <CustomeButton
                  onClick={(event) => this.authorizeHideModal3(event)}
                  style={{ marginRight: "24px", padding: "11px 20px", lineHeight: "normal" }}
                >
                  {i18n.t("BUTTON.CANCEL")}
                </CustomeButton>
                <CustomeButton onClick={() => this.acceptAuthorization3()} style={{ padding: "11px 20px", lineHeight: "normal" }}>
                  {i18n.t("BUTTON.ACCEPT")}
                </CustomeButton>
              </div>
              </>
            </Modal.Body>
          </Modal>

          <Modal
            size={this.state.isMaximized ? null : "lg"}
            show={this.state.authModalShow1}
            centered={!this.state.isMaximized}
            onHide={(event) => this.authorizeHideModal111(event)}
            backdrop="static"
            dialogClassName={this.state.isMaximized ? "modal-fullscreen" : ""}
          >
            <Modal.Header style={customStyle.modal_header}>
              <Modal.Title>
                {i18n.t("SUBMIT_APPLICATION.SHARE_TITLE")}
              </Modal.Title>
              <Grid item xs={2} sm={2} md={2} lg={2} style={{ display: "flex" }}>
                <Button
                    variant="light"
                    style={{ marginLeft: 'auto', visibility: "hidden"  }}
                    onClick={this.toggleMaximize}
                >
                    {this.state.isMaximized ?
                        <FullscreenExitIcon />
                        :
                        <FullscreenIcon />
                    }
                </Button>
                <Button onClick={(event) => this.authorizeHideModal111(event)}>
                    <CloseIcon />
                </Button>
            </Grid>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: this.state.isMaximized ? "100vh" : "450px",
                overflowY: "auto",
                textAlign: "justify",
                wordSpacing: "-2px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "15px",
              }}
            >
              {(this.props.agentDetails.clientId == '4599' || this.props.agentDetails.clientId == '5742') ?
              <>
                <div dangerouslySetInnerHTML={{__html:i18n.t("SUBMIT_APPLICATION.SHARE65")}}></div>
                  <div className="text-right" style={{ marginTop: "15px" }}>
                  <CustomeButton
                    onClick={(event) => this.authorizeHideModal1(event)}
                    style={{ marginRight: "24px", padding: "11px 20px", lineHeight: "normal" }}
                  >
                    {i18n.t("BUTTON.CANCEL")}
                  </CustomeButton>
                  <CustomeButton onClick={() => this.acceptAuthorization1()} style={{ padding: "11px 20px", lineHeight: "normal" }}>
                    {i18n.t("BUTTON.ACCEPT")}
                  </CustomeButton>
                </div>
              </>
              :
              <>
              {i18n.t("SUBMIT_APPLICATION.SHARE0")}
              <div style={{ paddingTop: "8px" }}>
                {i18n.t("SUBMIT_APPLICATION.SHARE1")}
              </div>
              <div style={{ paddingTop: "8px" }}>
                {i18n.t("SUBMIT_APPLICATION.SHARE2")}
              </div>
              <div style={{ paddingTop: "8px" }}>
                {i18n.t("SUBMIT_APPLICATION.SHARE3")}
              </div>
              <div style={{ paddingTop: "8px" }}>
                {i18n.t("SUBMIT_APPLICATION.SHARE4")}
              </div>
              <div style={{ paddingTop: "8px" }}>
                {i18n.t("SUBMIT_APPLICATION.SHARE5")}
              </div>
              <div style={{ paddingTop: "8px" }}>
                {i18n.t("SUBMIT_APPLICATION.SHARE6")}
              </div>
              <div style={{ paddingTop: "8px" }}>
                {i18n.t("SUBMIT_APPLICATION.SHARE61")}
              </div>
              <div style={{ paddingTop: "8px" }}>
                {i18n.t("SUBMIT_APPLICATION.SHARE62")}
              </div>
              <div style={{ paddingTop: "8px" }}>
                {i18n.t("SUBMIT_APPLICATION.SHARE63")}{" "}
                <b> {this.state.agentName} </b>,{" "}
                {i18n.t("SUBMIT_APPLICATION.SHARE64")}
              </div>

              <div style={{ paddingTop: "8px", fontWeight: "bold" }}>
                {i18n.t("SUBMIT_APPLICATION.SHARE_HEAD")}
              </div>
              <div style={{ paddingTop: "10px", fontWeight: "bold" }}>
                {i18n.t("SUBMIT_APPLICATION.SHARE_HEAD1")}
              </div>
              <div style={{ paddingTop: "8px" }}>
                {i18n.t("SUBMIT_APPLICATION.SHARE7")}
              </div>
              <div style={{ paddingTop: "8px", fontWeight: "bold" }}>
                {i18n.t("SUBMIT_APPLICATION.SHARE_HEAD2")}
              </div>
              <div style={{ paddingTop: "8px" }}>
                {i18n.t("SUBMIT_APPLICATION.SHARE8")}
              </div>
              <div style={{ paddingTop: "8px" }}>
                {i18n.t("SUBMIT_APPLICATION.SHARE9")}
              </div>
              <div className="text-right" style={{ marginTop: "15px" }}>
                <CustomeButton
                  onClick={(event) => this.authorizeHideModal1(event)}
                  style={{ marginRight: "24px", padding: "11px 20px", lineHeight: "normal" }}
                >
                  {i18n.t("BUTTON.CANCEL")}
                </CustomeButton>
                <CustomeButton onClick={() => this.acceptAuthorization1()} style={{ padding: "11px 20px", lineHeight: "normal" }}>
                  {i18n.t("BUTTON.ACCEPT")}
                </CustomeButton>
              </div>
              </>}
            </Modal.Body>
          </Modal>

          <Modal
            size={this.state.isMaximized ? null : "lg"}
            show={this.state.authModalShow}
            centered={!this.state.isMaximized}
            onHide={(event) => this.authorizeHideModal22(event)}
            backdrop="static"
            dialogClassName={this.state.isMaximized ? "modal-fullscreen" : ""}
          >
            <Modal.Header style={customStyle.modal_header}>
              <Modal.Title>
                {i18n.t("SUBMIT_APPLICATION.IMP_NOTICE")}
              </Modal.Title>
              <Grid item xs={2} sm={2} md={2} lg={2} style={{  display: "flex" }}>
                <Button
                    variant="light"
                    style={{ marginLeft: 'auto', visibility: "hidden"  }}
                    onClick={this.toggleMaximize}
                >
                    {this.state.isMaximized ?
                        <FullscreenExitIcon />
                        :
                        <FullscreenIcon />
                    }
                </Button>
                <Button onClick={(event) => this.authorizeHideModal22(event)}>
                    <CloseIcon />
                </Button>
            </Grid>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: this.state.isMaximized ? "100vh" : "450px",
                overflowY: "auto",
                textAlign: "justify",
                wordSpacing: "1px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "15px",
              }}
            >
              <div>
                <span
                  style={{
                    fontWeight: "bold",
                    wordSpacing: "1px",
                    textAlign: "left",
                  }}
                >
                  Authorization for Universal Health Fellowship & CarynHealth to
                  Contact Medical Provider :
                </span>
                <p style={{ marginTop: "20px" }}>To Whom It May Concern:</p>
                <span>
                  I, a covered individual (or the parent or legal guardian for
                  my minor) under{" "}
                  <span style={{ fontWeight: "bold" }}>
                    Universal HealthShare{" "}
                  </span>
                  (the “Program”), hereby request, authorize and grant authority
                  to Universal Health Fellowship (“UHF”), or its appointed
                  health plan manager CarynHealth Solutions, LLC
                  (“CarynHealth”), to contact and act on my behalf in dealing
                  with my physician and medical providers (the “Facility”) and
                  any other interested party in reference to charges for
                  treatment, care and services provided in connection with the
                  medical need and medical billing (the “Medical Bill”),
                  including without limitation charges that the Program has
                  determined exceed the Allowable Claim Limits under the terms
                  of the Program Document.
                </span>
                <br />
                <br />
                <p>
                  Additionally, by my acceptance, I acknowledge that I have
                  authorized the Facility to release any records and information
                  related to the Medical Bill, including Protected Health
                  Information (PHI), to UHF and CarynHealth. I am requesting
                  that such Protected Health Information be disclosed under this
                  authorization, as permitted by 164.508(1)(iv) of the privacy
                  regulations issued pursuant to the Health Insurance
                  Portability and Accountability Act (“HIPAA Privacy Rule”). I
                  have retained a copy of this authorization for my records. I
                  understand that I have the right to revoke this authorization
                  in writing, at any time, by sending a written statement of the
                  revocation to UHF and CarynHealth. Unless revoked, this
                  release will remain in effect and valid for one year from the
                  date of this authorization.
                </p>
              </div>
              <div className="text-right" style={{ marginTop: "15px" }}>
                <CustomeButton
                  onClick={(event) => this.authorizeHideModal(event)}
                  style={{ marginRight: "24px", padding: "11px 20px", lineHeight: "normal" }}
                >
                  {i18n.t("BUTTON.CANCEL")}
                </CustomeButton>
                <CustomeButton onClick={() => this.acceptAuthorization()} style={{ padding: "11px 20px", lineHeight: "normal" }}>
                  {i18n.t("BUTTON.ACCEPT")}
                </CustomeButton>
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            size={this.state.isMaximized ? null : "lg"}
            show={this.state.authModalShow4}
            centered={!this.state.isMaximized}
            onHide={(event) => this.hideModal4Privacy11(event)}
            backdrop="static"
            dialogClassName={this.state.isMaximized ? "modal-fullscreen" : ""}
          >
            <Modal.Header style={customStyle.modal_header}>
              <Modal.Title>Sharing Vs Insurance</Modal.Title>
              <Grid item xs={2} sm={2} md={2} lg={2} style={{  display: "flex" }}>
                <Button
                    variant="light"
                    style={{ marginLeft: 'auto', visibility: "hidden"  }}
                    onClick={this.toggleMaximize}
                >
                    {this.state.isMaximized ?
                        <FullscreenExitIcon />
                        :
                        <FullscreenIcon />
                    }
                </Button>
                <Button onClick={(event) => this.hideModal4Privacy11(event)}>
                    <CloseIcon />
                </Button>
            </Grid>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: this.state.isMaximized ? "100vh" : "450px",
                overflowY: "auto",
                textAlign: "justify",
                wordSpacing: "-2px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "15px",
              }}
            >
              {/* {this.state.loaderShow ? <Loader></Loader> : ""} */}
              <div style={{ paddingTop: "8px", fontWeight: "bold" }}>
                {i18n.t("MODAL_POPUP2.TITLE")}
              </div>
              <div style={{}}>
                <div style={{ paddingTop: "12px", fontWeight: "bold" }}>
                  {i18n.t("MODAL_POPUP2.QUESTION1")}
                </div>
              </div>

              <div style={{ paddingTop: "8px" }}>
                {i18n.t("MODAL_POPUP2.ANSWER1")}
              </div>

              <div style={{ paddingTop: "8px", fontWeight: "bold" }}>
                {i18n.t("MODAL_POPUP2.QUESTION2")}
              </div>

              <div style={{ paddingTop: "8px" }}>
                {i18n.t("MODAL_POPUP2.ANSWER2")}
              </div>

              <div style={{ paddingTop: "8px" }}>
                <ol>
                  <li style={{ paddingBottom: "15px" }}>
                    {" "}
                    {i18n.t("MODAL_POPUP2.ANSWER21")}
                  </li>
                  <li style={{ paddingBottom: "15px" }}>
                    {" "}
                    {i18n.t("MODAL_POPUP2.ANSWER22")}
                  </li>
                  <li style={{ paddingBottom: "15px" }}>
                    {" "}
                    {i18n.t("MODAL_POPUP2.ANSWER23")}
                  </li>
                  <li> {i18n.t("MODAL_POPUP2.ANSWER24")}</li>
                </ol>
              </div>
              <div style={{ paddingTop: "8px", fontWeight: "bold" }}>
                {i18n.t("MODAL_POPUP2.QUESTION3")}
              </div>

              <div style={{ paddingTop: "8px" }}>
                {i18n.t("MODAL_POPUP2.ANSWER3")}
              </div>
              <div style={{ paddingTop: "8px" }}>
                {i18n.t("MODAL_POPUP2.ANSWER31")}
              </div>
              <div style={{ paddingTop: "8px" }}>
                {i18n.t("MODAL_POPUP2.ANSWER32")}
              </div>
              <div
                style={{
                  paddingTop: "8px",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                {i18n.t("MODAL_POPUP2.ANSWER33")}
              </div>
              <div
                style={{
                  paddingTop: "8px",
                  fontWeight: "bold",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                {i18n.t("MODAL_POPUP2.QUESTION4")}
              </div>

              <div
                style={{
                  paddingTop: "8px",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                {i18n.t("MODAL_POPUP2.ANSWER4")}
              </div>
              <div
                style={{
                  paddingTop: "8px",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                {i18n.t("MODAL_POPUP2.ANSWER41")}
                <a
                  href="https://www.universalhealthfellowship.org/faqs/"
                  target="_blank"
                  rel="noopener"
                  style={{
                    color: "#1a2c40",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  {i18n.t("MODAL_POPUP2.READ")}
                </a>
              </div>
              <div
                style={{
                  paddingTop: "8px",
                  fontWeight: "bold",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                {i18n.t("MODAL_POPUP2.QUESTION5")}
              </div>

              <div
                style={{
                  paddingTop: "8px",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                {i18n.t("MODAL_POPUP2.ANSWER5")}
              </div>
              <div
                style={{
                  paddingTop: "8px",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                {i18n.t("MODAL_POPUP2.ANSWER51")}
                <span>
                  <a
                    href="http://www.universalhealthfellowship.org/wp-content/uploads/2020/02/UHS-State-Legal-Notices-UHS-SLN-22820.pdf"
                    target="_blank"
                    rel="noopener"
                    style={{
                      color: "#1a2c40",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                  >
                    {i18n.t("MODAL_POPUP2.ANSWER52")}
                  </a>
                </span>
              </div>
              <div
                style={{
                  paddingTop: "8px",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                {i18n.t("MODAL_POPUP2.ANSWER53")}
                <span>
                  <a
                    href="http://www.universalhealthfellowship.org/wp-content/uploads/2020/02/UHS-State-Mandate-Penalties-Disclaimer-UHS-SMPD-22820.pdf"
                    target="_blank"
                    rel="noopener"
                    style={{
                      color: "#1a2c40",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                  >
                    {i18n.t("MODAL_POPUP2.ANSWER52")}
                  </a>
                </span>
              </div>
              <div className="text-right" style={{ marginTop: "15px" }}>
                <CustomeButton
                  onClick={(event) => this.hideModal4Privacy(event)}
                  style={{ marginRight: "24px", padding: "11px 20px", lineHeight: "normal" }}
                >
                  {i18n.t("BUTTON.CANCEL")}
                </CustomeButton>
                <CustomeButton onClick={() => this.acceptPrivacyPolicy4()} style={{ padding: "11px 20px", lineHeight: "normal" }}>
                  {i18n.t("BUTTON.ACCEPT")}
                </CustomeButton>
              </div>
            </Modal.Body>
          </Modal>
        </Grid>
      );
    } else if (this.state.count === 2) {
      currentScreen = (
        <Grid item xs={12}>
          <Grid item xs={12} style={{ marginLeft: "16px" }}>
            <Typography
              variant="h6"
              component="h3"
              style={customeClasses.questionTitleText}
            >
              {i18n.t("SUBMIT_APPLICATION.TITLE")}
            </Typography>
          </Grid>

          <Grid item xs={12} style={{ marginTop: "10px", marginBottom: "5px" }}>
            <Grid item xs={2}>
              <Checkbox
                checked={this.state.authorization}
                inputProps={{
                  "aria-label": "secondary checkbox",
                }}
                style={{ color: "#1a2c40", marginLeft: -12 }}
                onClick={this.showFinanceAuthModal}
              />
            </Grid>

            <Grid
              item
              xs={10}
              onClick={this.showFinanceAuthModal}
              style={{
                cursor: "pointer",
                fontSize: "14.7px",
                lineHeight: "19px",
                display: "flex",
              }}
            >
              <div
                style={{
                  marginLeft: "25px",
                  marginTop: "-36px",
                  textAlign: "justify",
                }}
              >
                <span
                  style={{
                    cursor: "pointer",
                    fontSize: "14.7px",
                    lineHeight: "19px",
                    textAlign: "justify",
                    fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                  }}
                >
                  {this.props.reEnroll
                    ? i18n.t("SUBMIT_APPLICATION.ReEnrollAUTH") + " "
                    : (this.props.agentDetails.clientId == '4599' || this.props.agentDetails.clientId == '5742') ?
                    i18n.t("SUBMIT_APPLICATION.AUTH265")
                     : i18n.t("SUBMIT_APPLICATION.AUTHORIZE1") +
                      " " +
                      i18n.t("SUBMIT_APPLICATION.AUTH2")}
                  <span
                    style={{
                      color: "#1a2c40",
                      cursor: "pointer",
                      fontWeight: "bold",
                      borderBottom: "1px solid #1a2c40",
                    }}
                  >
                    {i18n.t("SUBMIT_APPLICATION.AUTH")}
                  </span>
                </span>
              </div>
            </Grid>
          </Grid>

          <Modal
            size="lg"
            show={this.state.financeAuthModalShow}
            centered
            onHide={(event) => this.hideModalFinaceAuth11(event)}
            backdrop="static"
          >
            <Modal.Header style={customStyle.modal_header} closeButton>
              <Modal.Title>
                {i18n.t("SUBMIT_APPLICATION.FINANCE_TITLE")}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body style={customStyle.financePopup}>
              {/* {this.state.loaderShow ? <Loader></Loader> : ""} */}
              <div style={{ paddingTop: "12px" }}>
                {i18n.t("SUBMIT_APPLICATION.FINANCE_BODY")}
              </div>
              <div style={{ paddingTop: "12px" }}>
                {i18n.t("SUBMIT_APPLICATION.FINANCE_BODY01")}
              </div>
              <div style={{ paddingTop: "12px" }}>
                {i18n.t("SUBMIT_APPLICATION.FINANCE_BODY02")}
              </div>

              <div className="text-right" style={{ marginTop: "15px" }}>
                <CustomeButton
                  onClick={(event) => this.hideModalFinaceAuth(event)}
                  style={{ marginRight: "24px", padding: "11px 20px", lineHeight: "normal" }}
                >
                  {i18n.t("BUTTON.CANCEL")}
                </CustomeButton>
                <CustomeButton onClick={() => this.acceptFinaceAuth()} style={{ padding: "11px 20px", lineHeight: "normal" }}>
                  {i18n.t("BUTTON.ACCEPT")}
                </CustomeButton>
              </div>
            </Modal.Body>
          </Modal>
        </Grid>
      );
    } else if (this.state.count === 3) {
      currentScreen = (
        // <>
        <div>
          <Grid item xs={12}>
            <Grid item xs={12} style={{ marginLeft: "16px" }}>
              <Typography
                variant="h6"
                component="h3"
                style={customeClasses.questionTitleText}
              >
                {i18n.t("SUBMIT_APPLICATION.TERMS")}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              style={{ marginTop: "10px", marginBottom: "5px" }}
            >
              <Grid item xs={2}>
                <Checkbox
                  checked={this.state.healthTerms}
                  inputProps={{
                    "aria-label": "secondary checkbox",
                  }}
                  style={{
                    color: "#1a2c40",
                    cursor: "pointer",
                    marginLeft: -12,
                  }}
                  onClick={this.showPlansModalHealth}
                ></Checkbox>
                {/* } */}
              </Grid>
              <Grid
                item
                xs={12}
                onClick={this.showFinanceAuthModal}
                style={{
                  cursor: "pointer",
                  lineHeight: "19px",
                  display: "flex",
                }}
                // onClick={this.showPlansModalHealth}
              >
                <div
                  style={{
                    marginLeft: "25px",
                    marginTop: "-33px",
                    fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                  }}
                >
                  <span
                    style={{
                      fontSize: "14px",
                      lineHeight: "19px",
                      cursor: "pointer",
                      textAlign: "justify",
                      fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                    }}
                    onClick={this.showPlansModalHealth}
                  ></span>
                  {i18n.t("SUBMIT_APPLICATION.TEXT4")}
                  <span
                    style={customeClasses.hyperTextScreen3}
                    onClick={this.showPlansModalHealth}
                  >
                    {i18n.t("SUBMIT_APPLICATION.TEXT5")}
                  </span>
                  {/* </span> */}
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Modal
            size={this.state.isMaximized ? null : "lg"}
            show={this.state.modalShow}
            centered={!this.state.isMaximized}
            onHide={(event) => this.viewPlanHideModalHealth1(event)}
            backdrop="static"
            dialogClassName={this.state.isMaximized ? "modal-fullscreen" : ""}
          >
            <Modal.Header style={customStyle.modal_header}>
              <Modal.Title>
                {i18n.t("SUBMIT_APPLICATION.MODEL_TITLE")}
              </Modal.Title>
              <Grid item xs={2} sm={2} md={2} lg={2} style={{ display: "flex" }}>
                  <Button
                      variant="light"
                      style={{ marginLeft: 'auto', visibility: "hidden"  }}
                      onClick={this.toggleMaximize}
                  >
                      {this.state.isMaximized ?
                          <FullscreenExitIcon />
                          :
                          <FullscreenIcon />
                      }
                  </Button>
                  <Button onClick={(event) => this.viewPlanHideModalHealth1(event)}>
                      <CloseIcon />
                  </Button>
              </Grid>
            </Modal.Header>
            <Modal.Body
              style={{
                maxHeight: this.state.isMaximized ? "100vh" : "450px",
                overflowY: "auto",
                textAlign: "justify",
                wordSpacing: "-2px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "15px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between"
              }}
            >
              <div>
              <div style={{ paddingTop: "8px", fontWeight: "bold" }}>
                {i18n.t("MODAL_LAST.QUESTION_LAST")}
              </div>

              <div style={{ paddingTop: "8px" }}>
                <ol style={{ marginLeft: "-25px" }}>
                  <li style={{ paddingBottom: "15px" }}>
                    {" "}
                    {i18n.t("MODAL_LAST.ANSWER1_LAST")}
                  </li>
                  <li style={{ paddingBottom: "15px" }}>
                    {" "}
                    {i18n.t("MODAL_LAST.ANSWER2_LAST")}
                  </li>
                  <li style={{ paddingBottom: "15px" }}>
                    {" "}
                    {i18n.t("MODAL_LAST.ANSWER3_LAST")}
                  </li>
                  <li style={{ paddingBottom: "15px" }}>
                    {" "}
                    {i18n.t("MODAL_LAST.ANSWER4_LAST")}
                  </li>
                  <li style={{ paddingBottom: "15px" }}>
                    {" "}
                    {i18n.t("MODAL_LAST.ANSWER5_LAST")}
                  </li>
                  <li style={{ paddingBottom: "15px" }}>
                    {" "}
                    {i18n.t("MODAL_LAST.ANSWER6_LAST")}
                  </li>
                  <li style={{ paddingBottom: "15px" }}>
                    {" "}
                    {i18n.t("MODAL_LAST.ANSWER7_LAST")}
                  </li>
                </ol>
              </div>
              </div>
              <div className="text-right" style={{ marginTop: "15px" }}>
                <CustomeButton
                  onClick={(event) => this.viewPlanHideModalHealth11(event)}
                  style={{ marginRight: "24px", padding: "11px 20px", lineHeight: "normal" }}
                >
                  {i18n.t("BUTTON.CANCEL")}
                </CustomeButton>
                <CustomeButton onClick={() => this.viewPlanHideModalHealth()} style={{ padding: "11px 20px", lineHeight: "normal" }}>
                  {i18n.t("BUTTON.ACCEPT")}
                </CustomeButton>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      );
    } else if (this.state.count === 4) {
      currentScreen = (
        <div>
          <Grid container spacing={4} justify="space-between">
            <Grid item xs={12} sm={6}>
              <Typography
                variant="h6"
                component="h3"
                style={customeClasses.questionTitleText}
              >
                E-Signature for enrollment
              </Typography>
              <Sample
                setChild={this.nameChangeHandler.bind(this)}
                name={"FirstName"}
                isValidFullName={this.state.isValidFullName}
                reqFlag={true}
                label={"Authorize this application by typing in your full name"}
                value={this.state.fullName}
                disable={false}
                style={customeClasses.textField}
                length={120}
                fieldType={"fullName"}
                errMsg={"Enter valid full name"}
                helperMsg={
                  "By typing my name above, I understand and agree that this form of electronic signature has the same legal force and affect as a manual signature."
                }
                parentDetails={{}}
              ></Sample>
              <div>
                <Typography
                  variant="h6"
                  component="h3"
                  style={customeClasses.questionTitleText}
                >
                  e-signature
                </Typography>
                <RadioGroup
                  row
                  aria-label="option"
                  name="row-radio-buttons-group"
                  value={this.state.signType}
                  onChange={(event, value) => {
                    this.changeSignType(event, value);
                    this.setState({
                      canvasChanged: false,
                      canvasDone: false,
                      disableSubmit:false
                    });
                  }}
                >
                  <FormControlLabel
                    value="stylized"
                    control={<PurpleRadio />}
                    label="Use stylized script"
                  />
                  <FormControlLabel
                    value="scribble"
                    control={<PurpleRadio />}
                    label="Let me draw"
                  />
                </RadioGroup>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "block",
                }}
              >
                {this.state.signType === "stylized" ? (
                  <>
                    <div id="txtsign" style={{ width: "100%", height: "100%" }}>
                      <TextSignature
                        id="textSignature"
                        text={this.state.fullName}
                        fontSize={50}
                      />
                    </div>
                  </>
                ) : (
                  <SignScroll
                    ref={this.child}
                    onCanvasChange={() =>
                      this.setState({
                        canvasChanged: true,
                      })
                    }
                    onCanvasClear={() =>
                      this.setState({
                        canvasChanged: false,
                      })
                    }
                  />
                )}
              </div>
              {this.state.signType !== "stylized" ? (
                <div>
                  <CustomeButton
                    variant="contained"
                    style={customeClasses.viewProgSum}
                    onClick={() => {
                      this.handleSignClear();
                      this.setState({ canvasChanged: false });
                    }}
                    disabled={this.state.canvasChanged ? false : true}
                  >
                    CLEAR
                  </CustomeButton>

                  <CustomeButton
                    variant="contained"
                    style={customeClasses.viewProgSum}
                    onClick={() => this.handleSignDone()}
                    disabled={this.state.canvasChanged ? false : true}
                  >
                    DONE
                  </CustomeButton>
                </div>
              ) : (
                <></>
              )}
            </Grid>
            <Grid
              item
            
              xs={12}
              sm={5}
              style={{
                textAlign: "justify",
                marginTop: "25px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "14px",
              }}
            >
              <span>
                By authorizing this application you agree that you have
                understood and accepted all terms and policies that have been
                explained to you by your Health Representative.{" "}
              </span>
            </Grid>
          </Grid>
        </div>
      );
    }

    return (
      <div style={{ ...customeClasses.root, display: "flex", flexDirection: "column" }}>
        {/* {this.state.loaderShow ? <Loader></Loader> : ""} */}
        {this.props.enrollingStepperType && this.state.loaderShow ? <Loader></Loader> : ""}

        {this.state.count < 5 && (
          <Grid
            id="grid_div"
            container
            spacing={1}
            style={{
              ...(this.props.isAgent
                ? this.state.fromMember
                  ? customeClasses.pt_auto
                  : customeClasses.pt_none
                : customeClasses.pt_auto),
              flexDirection: "column",
              flex: "1 1 auto",
            }}
          >
            <Grid item xs={12}>
              {!!!this.props.isAgent && <Grid item xs={12}>
                 <Typography component="p" style={customeClasses.rowText}>
                  {this.props.reEnroll
                    ? i18n.t("SUBMIT_APPLICATION.ReEnrollText3")
                    : i18n.t("SUBMIT_APPLICATION.TEXT3")}
                </Typography>
                <LinearProgress
                  variant="determinate"
                  classes={{
                    colorPrimary: classes.colorPrimary,
                    barColorPrimary: classes.barColorPrimary,
                  }}
                  style={classes.progress}
                  value={this.state.progress}
                />
              </Grid>}
              <Grid item xs={12} style={{}}>
                {currentScreen}
              </Grid>
            </Grid>
           {!!!this.props.isAgent && 
           <Grid item xs={12} sm={7} md={7} lg={7} style={{ marginTop: "auto" }}>
              {/*style={{marginTop:'30px'}}*/}
              <BackButton
                variant="contained"
                style={
                  // ((this.props.agentDetails.clientId == '4599' || this.props.agentDetails.clientId == '5742')) || (this.props.agentDetails.clientId != '4599' && this.props.agentDetails.clientId != '5742' && this.state.count === 1)
                  //   ? customeClasses.disabledButton
                  //   :
                     customeClasses.button
                }
                // disabled={(
                //   (this.props.agentDetails.clientId == '4599' || this.props.agentDetails.clientId == '5742')) || (this.props.agentDetails.clientId != '4599' && this.props.agentDetails.clientId != '5742' && this.state.count === 1) ? true : 
                //   false}
                onClick={this.reduceProgress}
              >
                {i18n.t("BUTTON.BACK")}
              </BackButton>
             {this.state.count != 4 &&  <WizardButton
                variant="contained"
                style={customeClasses.button}
                disabled={this.state.nextDisabled} /*&& this.state.healthTerms*/
                onClick={this.increaseProgress}
              >
                {i18n.t("BUTTON.NEXT")}
              </WizardButton>}
             {this.state.count === 4 && <FinishButton
                variant="contained"
                style={customeClasses.finishButton}
                disabled={
                  (this.state.count <= 4 && this.state.fullName === "") ||
                  (this.state.signType === "scribble" && !this.state.canvasDone) || this.state.disableSubmit
                }
                onClick={(e) => e.detail === 1 && (this.props.enrollingStepperType ? this.submitCarrierApplication() : this.beforeSaveApplication())}
              >
                {i18n.t("BUTTON.SUBMITAPPLICATION")}
              </FinishButton>}
            </Grid>}

            {this.state.count === 4 && (
              <Grid item xs={12} sm={5} md={5} lg={5}>
                {/* <CustomeButton
                  variant="contained"
                  href={(this.props.agentDetails.clientId == '4599' || this.props.agentDetails.clientId == '5742')?
                  AUTH_PDF_SFF_URL :
                    AUTH_PDF_URL}
                  target="_blank"
                  style={customeClasses.viewProgSum}
                >
                  DOWNLOAD AUTHORIZATIONS
                </CustomeButton> */}
              </Grid>
            )}

            <Modal
              size="md"
              show={this.state.successModal}
              centered
              onHide={() => this.handlenClose}
            >
              <Modal.Header style={customStyle.modal_header}>
                <Modal.Title>
                  {i18n.t("SUBMIT_APPLICATION.MODEL_TITLE2")}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div
                  style={{
                    textAlign: "center",
                    fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                  }}
                >
                  <p>{this.state.popUpMsg}</p>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <CustomeButton onClick={() => this.handleClose()} style={{ padding: "11px 20px", lineHeight: "normal" }}>
                  {i18n.t("BUTTON.OK")}
                </CustomeButton>
              </Modal.Footer>
            </Modal>
          </Grid>
        )}
        {this.state.count === 5 &&
        (this.state.fromMember == false || this.state.fromMember == null) ? (
          <Grid container spacing={3} style={{ textAlign: "center" }}>
            <Grid item xs={12}>
              <span
                style={{
                  fontSize: "25px",
                  fontWeight: "bold",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                {this.props.reEnroll
                  ? i18n.t("SUBMIT_APPLICATION.MESSAGE_REENROLL")
                  : i18n.t("SUBMIT_APPLICATION.MESSAGE")}
              </span>
            </Grid>
            <Grid item xs={12}>
              <span
                style={{
                  fontSize: "25px",
                  fontWeight: "bold",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                {i18n.t("SUBMIT_APPLICATION.MSG_2")}
              </span>
            </Grid>
            <Grid item xs={12}>
              <FinishButton
                variant="contained"
                style={{ width: "115px", height: "40px" }}
                onClick={() => this.handleLogout()}
              >
                LOGOUT
              </FinishButton>
            </Grid>
          </Grid>
        ) : (
          ""
        )}

        {this.state.count === 6 &&
        (this.state.fromMember == true || this.state.fromLogin) ? (
          <Grid container spacing={3} style={{ textAlign: "center" }}>
            <Grid item xs={12}>
              <span
                style={{
                  fontSize: "25px",
                  fontWeight: "bold",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                {this.props.reEnroll
                  ? i18n.t("SUBMIT_APPLICATION.MESSAGE_REENROLL")
                  : i18n.t("SUBMIT_APPLICATION.MESSAGE")}
              </span>
            </Grid>
            <Grid item xs={12}>
              <span
                style={{
                  fontSize: "25px",
                  fontWeight: "bold",
                  fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                }}
              >
                {i18n.t("SUBMIT_APPLICATION.MSG_2")}
              </span>
            </Grid>
            <Grid item xs={12}>
              <FinishButton
                variant="contained"
                style={{ width: "115px", height: "40px" }}
                onClick={() =>
                  this.state.fromLogin
                    ? this.handleLogout()
                    : this.handleReenrollClose()
                }
              >
                {this.state.fromLogin ? "LOGOUT" : "CLOSE"}
              </FinishButton>
            </Grid>
          </Grid>
        ) : (
          ""
        )}

        <Modal
          size="md"
          show={this.state.paymentScreenModal}
          onHide={(event) =>
            this.setState({ paymentScreenModal: false, loaderShow: false })
          }
          backdrop="static"
          centered
        >
          <Modal.Header style={customStyle.modal_header}>
            <Modal.Title>You’re done!</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
          
              textAlign: "justify",
              fontFamily: "Roboto, Arial, Helvetica, sans-serif",
              fontSize: "15px",
              fontWeight: "bold",
            }}
          >
            {/*The authorizations need to be done by the prospect. Hence please exit the enrollment wizard to return to your agent dashboard. On the actions menu of the prospect, click 'Send sign-up email' to invite them to complete the process.*/}
            {/*The final authorization must be completed by the prospect. Click the button below to send the authorization request email to the prospect. The prospect will need to click on the link in the email to access this page where they will see a program summary. If acceptable, the prospect will be prompted to type in their full name and click on SUBMIT APPLICATION to authorize this enrollment.*/}
            {/* This final step must be completed by the prospect. Click the button
            below to send the E-Signature request email to the prospect. The
            prospect will need to click on the link in the email to access this
            step. They will first review a summary of the program and accept the
            terms and policies. To authorize this enrollment the prospect will
            be prompted to type in their full name and click on SUBMIT
            APPLICATION. */}


            You have completed the application for one product. Please complete the application for another product, and then send the e-signature request via email or phone from the Agent Portal.
              <br /> <br />
Please click <b>“Go to Dashboard”</b> to continue and complete the remaining application.


          </Modal.Body>
          <Modal.Footer style={{ justifyContent: "center" }}>
            <BackButton
              style={{
                marginTop: "10px",
                marginRight: "14px",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "14px",
              }}
              onClick={() => this.handleBack()}
            >
              BACK
            </BackButton>{" "}

            <NextButton
              style={{
                marginTop: "10px",
                marginRight: "14px",
                padding: "11px 20px",
                lineHeight: "normal",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "14px",
              }}
              onClick={() => window.close()}
            >
              Go to Dashboard
            </NextButton>

            {/* <NextButton
              style={{
                marginTop: "10px",
                marginRight: "14px",
                padding: "11px 20px",
                lineHeight: "normal",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "14px",
              }}
              onClick={() => this.getEmailPhoneDetails("email")}
            >
              SEND e-Signature EMAIL
            </NextButton>
            <NextButton
              style={{
                marginTop: "10px",
                padding: "11px 20px",
                lineHeight: "normal",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "14px",
              }}
              disabled={this.props.reEnroll}
              onClick={() => this.getEmailPhoneDetails("sms")}
            >
              SEND e-Signature TEXT
            </NextButton> */}
          </Modal.Footer>
        </Modal>

        <Modal
          size="md"
          show={this.state.contactUpdateModal}
          onHide={() =>
            this.setState({ contactUpdateModal: false, loaderShow: false })
          }
          backdrop="static"
          centered
        >
          <Modal.Header style={customStyle.modal_header} closeButton>
            <Modal.Title>Contact Update</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              margin: "10px",
              textAlign: "justify",
              fontFamily: "Roboto, Arial, Helvetica, sans-serif",
              fontSize: "15px",
            }}
          >
            <div style={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  Confirm or update the prospect's contact details before sending the E-Signature request.
                </Grid>
                <Grid item xs={12}>
                  <Sample
                    setChild={(value, isValid) => {
                      if (isValid) this.setState({ contactUpdateEmail: value });
                    }}
                    reqFlag={true}
                    name={"contactUpdateEmail"}
                    label={"Email"}
                    value={this.state.contactUpdateEmail}
                    disable={false}
                    style={customStyle.textFieldWrp}
                    length={50}
                    fieldType={"email"}
                    errMsg={"Enter valid email Id"}
                    helperMsg={"Email is required"}
                    parentDetails={{ name: "contactUpdateEmail" }}
                  ></Sample>
                </Grid>
                <Grid item xs={12}>
                  <FilledTextField
                    fullWidth
                    variant="filled"
                    label={"Phone"}
                    required
                    value={formatPhoneDisplay(this.state.contactUpdateCountryCode, this.state.contactUpdatePhone)}
                    onChange={(e) => {
                      // The field always displays "<countryCode> XXX-XXX-XXXX" — strip that
                      // literal prefix first, then pull out just the digits, so the country
                      // code itself is never mistaken for part of the 10-digit number.
                      let raw = e.target.value;
                      if (raw.startsWith(this.state.contactUpdateCountryCode)) {
                        raw = raw.slice(this.state.contactUpdateCountryCode.length);
                      }
                      let digits = raw.replace(/\D/g, "").slice(0, 10);
                      this.setState({ contactUpdatePhone: digits });
                    }}
                    error={this.state.contactUpdatePhone.length > 0 && this.state.contactUpdatePhone.length < 10}
                    helperText={this.state.contactUpdatePhone.length > 0 && this.state.contactUpdatePhone.length < 10 ? "Enter valid mobile no." : ""}
                  />
                </Grid>
              </Grid>
            </div>
          </Modal.Body>
          <Modal.Footer >
            {/* <BackButton
              style={{
                marginTop: "10px",
                marginRight: "24px",
                padding: "11px 20px",
                lineHeight: "normal",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "14px",
              }}
              onClick={() => {
                this.setState({ contactUpdateModal: false, loaderShow: false });
              }}
            >
              CLOSE
            </BackButton> */}
            <NextButton
              style={{
                marginTop: "10px",
                padding: "11px 20px",
                lineHeight: "normal",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "14px",
              }}
              disabled={!this.state.contactUpdateEmail || this.state.contactUpdatePhone.length !== 10}
              onClick={() => this.confirmContactUpdate()}
            >
              SEND
            </NextButton>
          </Modal.Footer>
        </Modal>

        <Modal
          size="xl"
          show={this.state.FamilyDetailsMoreInfoModal}
          onHide={() =>
            this.setState({
              FamilyDetailsMoreInfoModal: false,
            })
          }
          backdrop="static"
          centered
        >
          <Modal.Header style={customStyle.modal_header}>
            <Modal.Title style={{ color: "black" }}>{(this.props.agentDetails.clientId == "5742" || this.props.agentDetails.clientId == "4599") ? `Member Details` : `Family Details`}</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              fontFamily: "Roboto, Arial, Helvetica, sans-serif",
              padding: "40px 20px",
              fontSize: "14px",
              textAlign: "justify",
            }}
          >
            <div>
              <div
                className={
                  this.props.reEnroll
                    ? "reEnrollTable familyDetailsTable reivewTable"
                    : "reivewTable familyDetailsTable"
                }
                style={{ overflowX: "auto" }}
              >
                {this.state.popTable && (
                  <CommonTable
                    quoteData={this.state.popTable.body}
                    check={true}
                    headerData={this.state.popTable.header}
                    tooltip={this.state.popTable.surchargeTooleTip}
                    quickQuote={false}
                    totalReq={true}
                    reEnroll={this.props.reEnroll}
                  />
                )}
              </div>
              <p
                style={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  paddingTop: "10px",
                }}
              >

              </p>
            </div>
          </Modal.Body>
          <Modal.Footer style={{ background: "#f1f1f1" }}>
            <ViewButton
              style={{ padding: "11px 20px", lineHeight: "normal" }}
              onClick={() =>
                this.setState({ FamilyDetailsMoreInfoModal: false })
              }
            >
              Done
            </ViewButton>
          </Modal.Footer>
        </Modal>

        <Modal
          size="xs"
          show={this.state.targetDateModal}
          onHide={(event) =>
            this.setState({ targetDateModal: false, loaderShow: false })
          }
          backdrop="static"
          centered
        >
          <Modal.Header style={customStyle.modal_header} closeButton>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              margin: "10px",
              fontFamily: "Roboto, Arial, Helvetica, sans-serif",
              fontSize: "14px",
            }}
          >
            <div style={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item sm={12} xs={12} md={6} lg={12}>
                  The Program Effective Date you selected is no longer valid.
                  Please select a new date when you'd prefer the benefit to
                  begin.
                </Grid>
                <Grid item sm={12} xs={12} md={6} lg={12}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      required
                      onBlur={() => this.setState({ birthDtFocus: true })}
                      onMouseOver={() => this.setState({ birthDt: true })}
                      onMouseLeave={() => this.setState({ birthDt: false })}
                      autoComplete="off"
                      margin="none"
                      id="date-picker-dialog"
                      label="Select Program Effective Date"
                      format="MM/dd/yyyy"
                      error={this.state.dateErr} //&&!this.state.todayDateValid
                      helperText={this.state.dateErr ? "Enter valid date" : ""} //this.state.todayDateValid?'Date Required':
                      value={myDate} //this.state.todayDateValid?null:
                      onFocus={(e) => e.target.blur()}
                      onCopy={this.handlerCopy}
                      onPaste={this.handlerCopy}
                      inputProps={{
                        style: {
                          fontSize: "18px",
                          fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                          paddingLeft: "11px",
                          paddingRight: "10px",
                          marginTop: "11px",
                          "&:focus": { outline: "none" },
                          color: !this.state.birthDt ? "grey" : "#1a2c40",
                        },
                      }}
                      InputLabelProps={{
                        style: {
                          paddingLeft: 10,
                          paddingRight: 10,
                          paddingTop: 12,
                          color: !this.state.birthDtFocus
                            ? "grey"
                            : this.state.birthDt
                            ? "#1a2c40"
                            : "grey",
                        },
                      }} //|| !this.state.todayDateValid
                      onChange={this.handleDateChange.bind(this)}
                      variant="filled"
                      // onMouseEnter={this.handleHover}
                      TextFieldComponent={CssTextField}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      style={{ width: "100%" }}
                      minDate={new Date(tomorrow)}
                      maxDate={new Date(futureDate)}
                    />
                    <span id="bd" style={customStyle.EnrollNew2Span}></span>
                  </MuiPickersUtilsProvider>
                </Grid>
              </Grid>
            </div>
          </Modal.Body>
          <Modal.Footer style={{ alignItems: "right" }}>
            <CustomeButton
              disabled={this.state.targetDate < new Date()}
              style={{ marginTop: "10px", padding: "11px 20px", lineHeight: "normal" }}
              onClick={() => this.openDraftDayModal()}
            >
              Done
            </CustomeButton>
          </Modal.Footer>
        </Modal>

        <Modal
          size="xs"
          show={this.state.carrierEffectiveDateModal}
          onHide={() =>
            this.setState({ carrierEffectiveDateModal: false, loaderShow: false })
          }
          backdrop="static"
          centered
        >
          <Modal.Header style={customStyle.modal_header} closeButton>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              margin: "10px",
              fontFamily: "Roboto, Arial, Helvetica, sans-serif",
              fontSize: "14px",
            }}
          >
            <div style={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid item sm={12} xs={12} md={6} lg={12}>
                  The Program Effective Date you selected is no longer valid.
                  Please select a new date when you'd prefer the benefit to
                  begin.
                </Grid>
                <Grid item sm={12} xs={12} md={6} lg={12}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      required
                      autoComplete="off"
                      margin="none"
                      id="carrier-effective-date-picker"
                      label="Select Program Effective Date"
                      format="MM/dd/yyyy"
                      value={this.state.carrierNewEffectiveDate}
                      onFocus={(e) => e.target.blur()}
                      onChange={(date) => this.setState({ carrierNewEffectiveDate: date })}
                      variant="filled"
                      TextFieldComponent={CssTextField}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      style={{ width: "100%" }}
                      minDate={moment().add(2, "days").toDate()}
                      maxDate={moment().add(45, "days").toDate()}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              </Grid>
            </div>
          </Modal.Body>
          <Modal.Footer style={{ alignItems: "right" }}>
            <CustomeButton
              disabled={!this.state.carrierNewEffectiveDate}
              style={{ marginTop: "10px", padding: "11px 20px", lineHeight: "normal" }}
              onClick={() => this.confirmCarrierEffectiveDate()}
            >
              Submit
            </CustomeButton>
          </Modal.Footer>
        </Modal>

        <Modal
          size="md"
          show={this.state.inviteStatusModal}
          centered
          onHide={() => this.closeInviteStatusModal}
        >
          <Modal.Header style={customStyle.modal_header}>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              style={{
                textAlign: "center",
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
              }}
            >
              <p>
                E-Signature link was already sent on {this.state.inviteStatus}
                . If you proceed to resend link, the prospect will not be able
                to sign-up with any previously sent links.
              </p>
              <p>Are you sure you want to proceed? </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <CustomeButton
              style={{ marginRight: "24px", padding: "11px 20px", lineHeight: "normal" }}
              onClick={() =>
                this.sendAuthRequest(this.state.reqType, this.state.phoneNumber)
              }
            >
              YES
            </CustomeButton>
            <CustomeButton
              style={{ padding: "11px 20px", lineHeight: "normal" }}
              onClick={() => this.closeInviteStatusModal()}
            >
              NO
            </CustomeButton>
          </Modal.Footer>
        </Modal>

        {/*------ Draft Day Modal ------*/}

        <Modal
          size="lg"
          show={this.state.draftDayModal}
          onHide={() => this.handleDraftModalClose()}
          backdrop="static"
          centered
        >
          <Modal.Header style={customStyle.modal_header} closeButton>
            <Modal.Title>Choose When You Want To Be Charged</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              minHeight: "430px",
              overflowY: "auto",
              textAlign: "justify",
              wordSpacing: "2px",
            }}
          >
            {/* {this.state.loaderShow ? <Loader></Loader> : ""} */}
            <p
              style={{
                textAlign: "left",
                fontSize: "15px",
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
              }}
            >
              To make it easier for you to plan your cash flow, you can decide
              when your monthly payment is processed. Please select how many
              days before payment due date, you would like your account to be
              charged.
            </p>

            <div>
              <FormControl component="fieldset">
                <RadioGroup
                  row
                  aria-label="days"
                  name="row-radio-buttons-group"
                  value={this.state.draftDaySelected}
                  onChange={(event) =>
                    this.answerChangeHandler(event, "radio", "")
                  }
                >
                  <FormControlLabel
                    value="5"
                    control={<PurpleRadio />}
                    label="5 days"
                  />
                  <FormControlLabel
                    value="7"
                    control={<PurpleRadio />}
                    label="7 days"
                  />
                  {/* <FormControlLabel
                    value="10"
                    control={<PurpleRadio />}
                    label="10 days"
                  />
                  <FormControlLabel
                    value="15"
                    control={<PurpleRadio />}
                    label="15 days"
                  /> */}
                </RadioGroup>
              </FormControl>
            </div>

            <div style={{ padding: "15px 0 0 0" }}>
              {this.state.draftDaySelected ? (
                <div>
                  <div className="row effectiveDateSection">
                    <div className="col-5">Program Effective Date</div>
                    <div className="col-2"></div>
                    <div className="col-5">
                      {this.state.effectivePaymentDate}
                    </div>
                  </div>

                  <div className="paymentDatesWrapper">
                    <h5>Key Payment Dates</h5>

                    <div className="row detailsTable detailsTableHeader">
                      <div className="col-4 col-md-5 detailsTableRow">
                        Description
                      </div>
                      <div className="col-4 col-md-2 detailsTableRow">
                        Amount
                      </div>
                      <div className="col-4 col-md-5 detailsTableRow">Date</div>
                    </div>

                    {
                      this.props.agentDetails.clientId != "5742" && this.props.agentDetails.clientId != "4599" ?
                      <div className="row detailsTable">
                        <div className="col-4 col-md-5 detailsTableRow">
                          Application Fee
                        </div>
                        <div className="col-4 col-md-2 detailsTableRow">
                          {this.state.initialApplicationFee}
                          {this.state.creditCard ? <span>&#42;</span> : null}
                        </div>
                        <div className="col-4 col-md-5 detailsTableRow">
                          {this.state.todayDate}
                        </div>
                      </div>
                      :<></>
                    }
                    

                    <div className="row detailsTable">
                      <div className="col-4 col-md-5 detailsTableRow">
                        First Payment
                      </div>
                      <div className="col-4 col-md-2 detailsTableRow">
                        ${this.state.firstPaymentAmount}
                        {this.state.creditCard ? <span>&#42;</span> : null}
                      </div>
                      <div className="col-4 col-md-5 detailsTableRow">
                        {this.state.firstPaymentDate}
                      </div>
                    </div>

                    <div className="row detailsTable">
                      <div className="col-4 col-md-5 detailsTableRow">
                        Recurring Monthly Payments
                      </div>
                      <div className="col-4 col-md-2 detailsTableRow">
                        ${this.state.firstPaymentAmount}
                        {this.state.creditCard ? <span>&#42;</span> : null}
                      </div>
                      <div className="col-4 col-md-5 detailsTableRow">
                        {this.state.subsequentPaymentDate}
                        <sup>+</sup>
                      </div>
                    </div>

                    <div style={{ padding: "5px 10px" }}>
                      {this.state.creditCard ? (
                        <h6>
                          <span>&#42;</span>3.5% merchant fees apply on credit
                          card payments
                        </h6>
                      ) : null}
                      <h6>
                        <span>
                          <sup>+</sup>
                        </span>
                        The actual date may change based on the number of days
                        in the month
                      </h6>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <CustomeButton
              onClick={() => this.handleDraftModalClose()}
              style={{ ...customStyle.m10, marginRight: "24px", padding: "11px 20px", lineHeight: "normal" }}
            >
              {i18n.t("BUTTON.CANCEL")}
            </CustomeButton>
            <CustomeButton
              disabled={this.state.firstPaymentDate ? false : true}
              onClick={this.submitDraftDay}
              style={{ ...customStyle.m10, padding: "11px 20px", lineHeight: "normal" }}
            >
              Submit
            </CustomeButton>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    subId: state.subId,
    email: state.email,
  };
};

export default withStyles(styles)(connect(mapStateToProps)(SubmitApplication));
